var checkout4i = function () {
	"use strict";

	var forms = new forms4i(),
		tooltips = new toolTips(),
		accordions = new getAccordions4i(),
		maps = new maps4i(),
		updatedBillingAddresses, creditCardIds, triggerEl, deleteModal,
		jsMessages = {},
		windowWidth = window.innerWidth,
		errorMsgPanel = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
			'<ul id="ErrorMsgBox"><li tabindex="0" class="errorItem"></li></ul>' +
			'</div>',
		login = {},
		loginStatuses = {},
		emptyGuid = "00000000-0000-0000-0000-000000000000",
		verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value,
		cartId = document.getElementById("cartId").value,
		kaID, confirmModal,
        pendingSubmitAfterCCSave = false,

		init = function () {
			jsMessages = JSON.parse(document.getElementById('JsMessages').value);
			formEvents.UpdateView();
			formEvents.CheckIfSmallScreen();
			formEvents.CheckCartHasCoupon();
			detailsDialog.Init();
			deleteDialog.Init();
			confirmDialog.Init();

			formEvents.BindShipAddressEvents();
			formEvents.BindShipMethodEvents();
			formEvents.BindPaymentMethodEvents();

			login = new loginService(forms, formEvents.ShowNewAddressForm);
			loginStatuses = login.LoginStatuses;

			accordions.init(document.getElementById("mainContent"));
			updateAccordionCSS();
			tooltips.init(); // tax exempt tooltips

			if (document.getElementById("btnCancelCouponCode")) {
				document.getElementById("btnCancelCouponCode").addEventListener("click", function (e) {
					e.preventDefault();
					formEvents.HideEnterCouponCode();
				});
				document.getElementById("btnEnterCouponCode").addEventListener("click", formEvents.ShowEnterCouponCode);
				document.getElementById("btnApplyCouponCode").addEventListener("click", formEvents.SubmitCouponCode);
				document.getElementById("removeCouponCode").addEventListener("click", ajaxActions.DeleteCouponCode);
			}

			document.getElementById("btnPlaceOrder").addEventListener("click", function (e) {
				e.preventDefault();
				document.getElementById("btnPlaceOrder").disabled = true;
				forms.ClearValidation();

				if (document.getElementById("shipAddressStatus").querySelector("span")
					&& document.getElementById("shipAddressStatus").querySelector("span").innerHTML.substring("step") != -1
					|| document.getElementById("editShippingAddress").classList.contains("hide")) {
					document.getElementById("btnPlaceOrder").disabled = false;
					document.getElementById("divCartNotifications").insertAdjacentHTML('afterbegin', errorMsgPanel);

					if (document.getElementsByClassName("btnUseShipAddress")[0]) {
						var id = document.getElementsByClassName("btnUseShipAddress")[0].getAttribute("data-ship-address-id");
						document.getElementsByClassName("errorItem")[0].innerHTML = "<a href='#" + id + "'>Please select a shipping address.</a>";
					}
					else if (document.getElementById("FirstName")) {
						document.getElementsByClassName("errorItem")[0].innerHTML = "<a href='#FirstName'>Please enter a shipping address.</a>";
					}
					else {
						document.getElementsByClassName("errorItem")[0].innerHTML = "Please enter a shipping address.";
					}

					document.getElementById("ErrorBox").scrollIntoView({ behavior: "smooth" });

					if (document.getElementById("FirstName")) {
						document.getElementById("FirstName").focus();
					}
				}
				else if ((document.getElementById("shipMethodStatus").querySelector("span")
					&& document.getElementById("shipMethodStatus").querySelector("span").innerHTML.substring("step") != -1)
					|| !document.getElementById("loadingStep2").classList.contains("hide")) {
					document.getElementById("btnPlaceOrder").disabled = false;
					document.getElementById("divCartNotifications").insertAdjacentHTML('afterbegin', errorMsgPanel);
					var id = document.getElementById("divShippingMethodItems").getElementsByTagName("input")[0].id;
					document.getElementsByClassName("errorItem")[0].innerHTML = "<a href='#" + id + "'>Please select a shipping method.</a>";
					document.getElementById("ErrorBox").scrollIntoView({ behavior: "smooth" });
					document.getElementById("divShippingMethodItems").querySelector("input").focus();
				}
				else if ((document.getElementById("divSelectPaymentMethod").classList.contains("hide")
					&& document.getElementById("divListPaymentMethod").classList.contains("hide"))
					|| !document.getElementById("loadingStep3").classList.contains("hide")
					|| document.getElementById("editPaymentMethod").classList.contains("hide")) {

                    var valid = true;
					if (document.getElementById("divCreditCardFormBlock")) {
						[].slice.call(document.getElementById("divCreditCardFormBlock").getElementsByClassName("form2018")[0].querySelectorAll(".txtReq")).forEach(function (el, index, array) {
							if (el.value === "") valid = false;
						});
					}

                    if (document.getElementById("divBillAddress")
						&& document.getElementById("divBillAddress").classList.contains("hide")
						&& valid) {
						forms.ClearValidation();
						document.getElementById("divCartNotifications").insertAdjacentHTML('afterbegin', errorMsgPanel);
						document.getElementsByClassName("errorItem")[0].innerHTML = "<a href='#UseShippingAddress'>Please enter your billing address.</a>";
						document.getElementById("ErrorBox").scrollIntoView({ behavior: "smooth" });
                        document.getElementById("btnPlaceOrder").disabled = false;
                        return;
                    }

					// If a CC form is visible, determine if it's an edit vs a new card
					var ccFormBlock = document.getElementById("divCreditCardFormBlock");
					if (ccFormBlock && !ccFormBlock.classList.contains("hide")) {
						var cardIdEl = document.getElementById("CardID");
						var isEditExisting = false;
                        //if there is a cardId, they are editing an existing card
						if (cardIdEl && cardIdEl.value && cardIdEl.value.trim() !== "") {
							isEditExisting = true;
						}

                        var cardValidated = false;
						if (isEditExisting) {
                            e.preventDefault();
							forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () { cardValidated = true; formEvents.SaveCC(cardIdEl.value); }, e);
						}
                        else
                        {
                            //check if they are a newCustomer or just adding a new card
                            var divNewCustomer = document.getElementById("divNewPaymentMethod");
                            if(divNewCustomer && divNewCustomer.classList.contains("hide"))
                            {
                                e.preventDefault();
                                forms.UnmaskCCNumber(document.getElementById("CardNumber"));
                                forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () { cardValidated = true; formEvents.SaveCC(""); }, e);
                                forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
                            }
                            else
                            {
                                e.preventDefault();
                                forms.UnmaskCCNumber(document.getElementById("CardNumber"));
                                forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () { cardValidated = true; formEvents.SaveCC("", true); }, e);
                                forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
                            }
                        }
                        if(cardValidated)
                        {
                            pendingSubmitAfterCCSave = true;
                            return;
                        }
                        else
                        {
                            document.getElementById("btnPlaceOrder").disabled = false;
                        }
					}

					document.getElementById("btnPlaceOrder").disabled = false;
					document.getElementById("divCartNotifications").insertAdjacentHTML('afterbegin', errorMsgPanel);
					document.getElementsByClassName("errorItem")[0].innerHTML = "<a href='#ccpayopt'>Please enter a payment method.</a>";
					document.getElementById("ErrorBox").scrollIntoView({ behavior: "smooth" });
				}
				else {
					forms.formValidation(document.getElementById("divListPaymentMethod"), ajaxActions.SubmitOrder, e);
				}
			});

			const kaElement = document.getElementById('KaID');
			if (kaElement) {
				kaID = kaElement.value;
				const kaENV = kaElement.getAttribute('data-env');

				let kountConfig = {
					clientID: 300807,
					environment: kaENV,
					isSinglePageApp: false,
					isDebugEnabled: kaENV == 'TEST'
				};

				const kount = kountSDK(kountConfig, kaID);
				if (kount && kaENV == 'TEST') console.log('Kount SDK loaded');
			}

			if (document.getElementById("editShippingAddress")) {
				document.getElementById("editShippingAddress").addEventListener("click", function (e) {
					e.preventDefault();
					this.setAttribute("aria-expanded", "true");
					formEvents.HidePaymentLoad();
					formEvents.ShippingAddressEditMode();
					formEvents.UpdateView();
				});
			}
			if (document.getElementById("editPaymentMethod")) {
				document.getElementById("editPaymentMethod").addEventListener("click", function (e) {
					e.preventDefault();
					this.setAttribute("aria-expanded", "true");
					formEvents.PaymentMethodEditMode = true;
					if (document.getElementsByClassName("ccDisplay")[0]) {
						formEvents.DisplayFlag = document.getElementsByClassName("ccDisplay")[0].innerHTML === "" ? true : false;
					}
					formEvents.UpdateView();
				});
			}

			var email = document.getElementById('Email');
			if (email) {
				document.getElementById("placeOrderPanel").classList.add('hide');
			}
		},

		updateAccordionCSS = function () { //hack so the tooltips will not be cut off by the overflow hidden on accordion panel
			var orderSumAccordion = document.getElementById("orderSummaryBody");
			if (orderSumAccordion.classList.contains("open")) {
				orderSumAccordion.style.overflow = "visible";
			}
			document.getElementById("orderSummaryHeader").querySelector("button").addEventListener("click", function (e) {
				if (orderSumAccordion.getAttribute("aria-hidden") === "false") {
					orderSumAccordion.style.overflow = "visible";
				} else {
					orderSumAccordion.style.overflow = "hidden";
				}
			});
		},

		detailsDialog = (function () {
			let detailsModal,
				init = () => {
					detailsModal = new Dialog4i();
					const dialogContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading example dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
					detailsModal.Init({
						triggerElements: [].slice.call(document.querySelectorAll(".cartDetailsBtn")),
						dialogClass: "mediumDialog",
						title: "Imprint Charges",
						content: dialogContent,
						onOpen: showDetailsPopup
					});
				},
				showDetailsPopup = (line) => {
					fetch('/checkout/extradetails', {
						method: 'POST',
						body: JSON.stringify({ cartId: cartId, cartItemId: line.getAttribute("data-cart-item-id") }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.text() : [];
					}).then(function (response) {
						const popup = document.getElementById('popUpDialog').querySelector(".dialogContent");
						popup.innerHTML = response;
						formEvents.HideAjaxMessage();
					}).catch(function (error) {
						detailsModal.Close();
						formEvents.ShowAjaxMessage(jsMessages.getItemDetailsError);
					});
				};
			return {
				Init: init
			};
		})(),

		deleteDialog = (function () {
			let dialog,

				init = () => {
					deleteModal = new Dialog4i();
					deleteModal.Init({
						triggerElements: [].slice.call(document.querySelectorAll(".btnDeleteShipAddress, .btnDeleteCC")),
						dialogClass: "smallDialog",
						title: "Delete?",
						content: getContent(),
						onOpen: open,
						onClose: close
					});
				},
				getContent = () => {
					return '<div class="displayFlex flexJustifyEnd flexAlignItemsCenter">' +
						'<button class="close4iDialog btnToHyp underline text16 marginRight20" type="button">Cancel</button>' +
						'<button id="btnConfirmDelete" class="button-md bkgdBlue text16" type="button">Delete</button>' +
						'</div>';
				},
				open = (el) => {
					const shipAddress = el.getAttribute("data-ship-address-id");
					const ccId = el.getAttribute("data-card-id");
					dialog = document.getElementById("popUpDialog");
					let header;
					if (shipAddress) {
						header = document.getElementById("DeleteAddressLabel").value;
						dialog.getElementsByTagName('h2')[0].innerHTML = header;
						dialog.setAttribute("data-delete-type", "S");
						dialog.setAttribute("data-address-id", shipAddress);
					}
					if (ccId) {
						header = document.getElementById("DeleteCreditCardLabel").value;
						dialog.getElementsByTagName('h2')[0].innerHTML = header;
						dialog.setAttribute("data-delete-type", "CC");
						dialog.setAttribute("data-card-id", ccId);
					}

					const submitBtn = document.getElementById("btnConfirmDelete");
					submitBtn.addEventListener("click", deleteConfirmed);
				},
				close = () => {
					dialog.setAttribute("data-address-id", "");
					dialog.setAttribute("data-delete-type", "");
				},
				deleteConfirmed = () => {
					if (dialog.getAttribute("data-delete-type") === "S")
						deleteShippingAddress(dialog.getAttribute("data-address-id"));
					else if (dialog.getAttribute("data-delete-type") === "CC")
						deleteCC(dialog.getAttribute("data-card-id"));
				},
				deleteShippingAddress = (addressId) => {
					deleteModal.Close();
					formEvents.LoadAddress();

					fetch('/checkout/ajaxdeleteaddress', {
						method: 'POST',
						body: JSON.stringify({ id: addressId }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) response = ajaxActions.ParseAjaxResponse(response);
						if (response.success) {
							formEvents.RemoveShippingAddress(addressId);
							updatedBillingAddresses = response.partialView1;
							formEvents.UpdateBillingAddressList(updatedBillingAddresses);
							formEvents.BindBillingAddressListEvents();
						} else {
							if (response.message !== null) formEvents.ShowAjaxMessage(response.message);
							else formEvents.ShowAjaxMessage("Could not update shipping address. Refresh page and try again.");
						}
						formEvents.HideAddressLoad();
					}).catch(function (error) {
						formEvents.HideAddressLoad();
						formEvents.ShowAjaxMessage(jsMessages.updateShippingAddressError);
					});
				},
				deleteCC = (cardId) => {
					deleteModal.Close();
					formEvents.LoadPayment();

					fetch('/checkout/deletecreditcard', {
						method: 'POST',
						body: JSON.stringify({ id: cardId }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) response = ajaxActions.ParseAjaxResponse(response);
						if (response.success) {
							formEvents.RemoveCreditCard(cardId);
							formEvents.LoadPayment();
							if (parseInt(document.getElementById("PaymentMethods_Count").value) === 1) {
								document.getElementById("PaymentMethods_Count").value = 0;
								formEvents.ShowPaymentMethodPanel();
								if (document.getElementById("CardName")) {
									document.getElementById("CardName").focus();
									document.getElementById("CardName").scrollIntoView({ top: 0, behavior: "smooth" });
								}
							} else {
								document.getElementById("PaymentMethods_Count").value = parseInt(document.getElementById("PaymentMethods_Count").value) > 1 ? parseInt(document.getElementById("PaymentMethods_Count").value) - 1 : 1;
							}
						} else {
							if (response.message !== null) formEvents.ShowAjaxMessage(response.message);
							else formEvents.ShowAjaxMessage("Could not delete the card. Refresh page and try again.");
						}
						if (parseInt(document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : "") !== 0) {
							formEvents.HidePaymentLoad();
						}
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						formEvents.ShowAjaxMessage(jsMessages.deleteCCError);
					});
				};
			return {
				Init: init
			};
		})(),

		confirmDialog = (function () {
			let dialog,
				init = () => {
					confirmModal = new Dialog4i();
					confirmModal.Init({
						triggerElements: [],
						dialogClass: "smallDialog",
						title: "Save this address?",
						content: getContent(),
						onOpen: open,
						onClose: close
					});
				},
				getContent = () => {
					return '<p id="confirmSaveDesc" class="textSemiBold paddingBtm10">This address is also linked to a credit card. Update both addresses?</p>' +
						'<div class="displayFlex flexJustifyEnd">' +
						'<button id="btnConfirmNo" class="bkgdWhite button-md marginRight20" type="button">No</button>' +
						'<button id="btnConfirmYes" class="button-md bkgdBlue" type="button">Yes</button>' +
						'</div> ';
				},
				open = () => {
					var addressId = document.getElementById("AddressId").value;
					dialog = document.getElementById("popUpDialog");
					dialog.querySelector(".close4iDialog").classList.add("hide");

					if (addressId) {
						dialog.setAttribute("data-save-type", "S");
						dialog.setAttribute("data-address-id", addressId);
					}

					document.getElementById("btnConfirmYes").addEventListener("click", confirmSave);
					document.getElementById("btnConfirmNo").addEventListener("click", cancelSave);
				},
				close = () => {
					formEvents.HideBusy();
				},
				confirmSave = function (e) {
					e.preventDefault();
					if (dialog.getAttribute("data-save-type") === "S") {
						var shipAddress = addressMethods.GetEditShippingAddress(dialog.getAttribute("data-address-id"));
						confirmModal.Close();
						ajaxActions.SaveShippingAddress(shipAddress);
						if (shipAddress) addressMethods.UpdateSelectedBillingAddressOnChange(shipAddress);
					}
				},
				cancelSave = function (e) {
					e.preventDefault();
					if (dialog.getAttribute("data-save-type") === "S") {
						var shipAddress = addressMethods.GetEditShippingAddress(dialog.getAttribute("data-address-id"));
						shipAddress.AddressId = "";
						confirmModal.Close();
						ajaxActions.SaveShippingAddress(shipAddress);
					}
				};

			return {
				Init: init
			};
		})(),

		ajaxActions = (function () {
			//Net Core does not like leading underscores on __RequestVerificationToken for the header
			var creditCardErrorCount = 0,

				getCreditCardIds = function (callback) {
					fetch('/checkout/getpaymentypes', {
						method: 'GET',
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						creditCardIds = response;
						if (typeof callback === 'function') {
							callback(creditCardIds);
						}
					}).catch(function (error) {
						formEvents.ShowAjaxMessage(jsMessages.getCreditCardIds);
					});
				},

				getAddressForm = function (container, callBack) {
					// get blank address form		
					fetch('/checkout/getaddressform', {
						method: 'GET',
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function (response) {
						return (response.ok) ? response.text() : [];
					}).then(function (response) {
						formEvents.HideBusy();
						formEvents.HideAddressLoad();
						container.innerHTML = response;
						formEvents.BindAddressAutoComplete();
						container.scrollIntoView({ top: 0, behavior: "smooth" });
						callBack();
					}).catch(function (error) {
						formEvents.HideBusy();
						formEvents.HideAddressLoad();
						container.innerHTML = jsMessages.getAddressFormError;
						container.scrollIntoView({ top: 0, behavior: "smooth" });
					});
				},

				getCCForm = function (container, callBack) {
					fetch('/checkout/getccform', {
						method: 'GET',
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function (response) {
						return (response.ok) ? response.text() : [];
					}).then(function (response) {
						if (container !== "" && container.innerHTML !== response) {
							container.innerHTML = response;
							formEvents.BindAddressAutoComplete();
						}
						callBack();
					}).catch(function (error) {
						if (container !== "") {
							container.innerHTML = jsMessages.getCCFormError;
						}
						formEvents.HidePaymentLoad();
					});
				},

				addCouponCode = function (code) {
					formEvents.LoadCoupon();

					fetch('/cart/addcoupon', {
						method: 'POST',
						body: JSON.stringify({ cartId: cartId, couponCode: code }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
						}
						if (response.success) {
							formEvents.AddCouponCode(response, code);
							omniture.AddCouponCode(code);
						} else {
							formEvents.HideLoadCoupon();
							if (response.message !== null) {
								formEvents.CouponCodeError(response.message);
							} else {
								formEvents.CouponCodeError("There was an error with the coupon code. Please try again.");
							}
						}
					}).catch(function (error) {
						formEvents.HideLoadCoupon();
						formEvents.CouponCodeError(jsMessages.couponError);
					});
				},

				deleteCouponCode = function (e) {
					var coupon = e.currentTarget;
					formEvents.LoadCoupon();
					var code = coupon.getAttribute("data-coupon-code");

					fetch('/cart/deletecoupon', {
						method: 'POST',
						body: JSON.stringify({ cartId: cartId, couponCode: code }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
						}
						if (response.success) {
							formEvents.DeleteCouponCode(response, code);
							formEvents.HideAjaxMessage();
						} else {
							formEvents.HideLoadCoupon();
							if (response.message !== null) {
								formEvents.ShowAjaxMessage(response.message);
							} else {
								formEvents.ShowAjaxMessage("There was an error removing your coupon code. Please refresh page and try again.");
							}
						}
					}).catch(function (error) {
						formEvents.HideLoadCoupon();
						formEvents.ShowAjaxMessage(jsMessages.deleteCouponError);
					});
				},

				saveShippingAddress = function (shipAddress) {
					formEvents.LoadAddress();
					shipAddress.CartId = cartId;
					shipAddress.AddressId = shipAddress.AddressId === "" ? "00000000-0000-0000-0000-000000000000" : shipAddress.AddressId;

					fetch('/checkout/updateshipaddress', {
						method: 'POST',
						body: JSON.stringify(shipAddress),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
							if (response.newAddressId && response.newAddressId !== emptyGuid) {
								shipAddress.AddressId = response.newAddressId;
							}
						}
						if (response.success) {
							formEvents.UpdateCartTotals(response);
							omniture.ShipAddress();

							formEvents.UpdateShippingAddress(response.partialView1, shipAddress.AddressId);
							formEvents.UpdateShippingMethods(response.partialView2);
							updatedBillingAddresses = response.message;
							formEvents.UpdateBillingAddressList(response.message);
							formEvents.BindBillingAddressListEvents();
							formEvents.ResetShipAddressHeight();
							formEvents.ShowPaymentMethodPanel();
							document.getElementById("editShippingAddress").setAttribute("aria-expanded", "false");
						} else {
							if (response.message.indexOf("ErrorMsgPanel") === -1) {
								document.getElementById("divAddressFormBlock").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', errorMsgPanel);
								document.getElementsByClassName("ErrorMsgPanel")[0].getElementsByClassName("errorItem")[0].innerHTML = response.message;
							}
							else {
								document.getElementById("divAddressFormBlock").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', response.message);
							}
							formEvents.CalculateDivShippingAddressHeight("#divAddressFormBlock");
						}
						formEvents.HideAjaxMessage();
						formEvents.HideAddressLoad();
					}).catch(function (error) {
						formEvents.CalculateDivShippingAddressHeight("#divAddressFormBlock");
						formEvents.HideAddressLoad();
						formEvents.ShowAjaxMessage(jsMessages.updateShippingAddressError);
					});
				},

				updateItemFreight = function (id) {
					var ids = id.split("_");
					if (ids.length < 2) {
						formEvents.ShowAjaxMessage(jsMessages.parseFreightOptionError);
						return;
					}
					formEvents.LoadFreight();

					fetch('/checkout/setshipmethod', {
						method: 'POST',
						body: JSON.stringify({ cartId: cartId, cartItemId: ids[1], methodId: ids[0] }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
						}
						if (response.success) {
							formEvents.UpdateCartTotals(response);
							formEvents.HideAjaxMessage();
							omniture.ShipMethod();
						} else {
							if (response.message !== null) {
								formEvents.ShowAjaxMessage(response.message);
							} else {
								formEvents.ShowAjaxMessage("Could not update freight option. Refresh page and try again.");
							}
						}
						formEvents.HideFreightLoad();
						document.getElementById(id).focus();
					}).catch(function (error) {
						formEvents.HideFreightLoad();
						formEvents.ShowAjaxMessage(jsMessages.updateFreightError);
					});
				},

				setPaymentMethod = function (cardId) {
					formEvents.LoadPayment();
					formEvents.ClearPaymentMethodError();

					fetch('/checkout/setcreditcard', {
						method: 'POST',
						body: JSON.stringify({ cartId: cartId, methodId: cardId }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
						}
						if (response.success) {
							formEvents.PaymentMethodEditMode = false;
							formEvents.UpdatePaymentMethods(response.partialView1, response.message);
							document.getElementById("editPaymentMethod").setAttribute("aria-expanded", "false");
						} else {
							if (response.message !== null) {
								formEvents.SettingPaymentMethodError(response.message);
							} else {
								formEvents.SettingPaymentMethodError("Could not update payment method. Refresh page and try again.");
							}
						}
						formEvents.HideAjaxMessage();
						formEvents.HidePaymentLoad();
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						formEvents.ShowAjaxMessage(jsMessages.setPaymentMethodError);
					});
				},

				setPaymentMethodInvoice = function () {
					formEvents.LoadPayment();
					formEvents.ClearPaymentMethodError();

					fetch('/checkout/setinvoicepayment', {
						method: 'POST',
						body: JSON.stringify({ cartId: cartId }),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
						}
						if (response.success) {
							formEvents.PaymentMethodEditMode = false;
							formEvents.UpdatePaymentMethodInvoice();
							document.getElementById("editPaymentMethod").setAttribute("aria-expanded", "false");
						} else {
							if (response.message !== null) {
								formEvents.SettingPaymentMethodError(response.message);
							} else {
								formEvents.SettingPaymentMethodError("Could not update payment method. Refresh page and try again.");
							}
						}
						formEvents.HideAjaxMessage();
						formEvents.HidePaymentLoad();
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						formEvents.ShowAjaxMessage(jsMessages.setPaymentMethodError);
					});
				},

				updateShippingAddress = function (element) {
					formEvents.ClearShippingAddressError();
					var addressId = element.getAttribute("data-ship-address-id").trim();
					document.getElementById("editShippingAddress").setAttribute("aria-expanded", "false");
					if (document.getElementById("divSelectShipAddress").querySelector("p").textContent === addressId) {
						formEvents.ShowPaymentMethodPanel();
						formEvents.ShippingAddressDefaultMode();
						return;
					} else {
						var shipAddress = addressMethods.GetExistingAddress("#divShipAddress_" + addressId, addressMethods.ShippingAddressTypeId);
						if (!shipAddress) {
							return;
						}
						saveShippingAddress(shipAddress);
					}
				},

				showErrorValidation = function (targetEl, response) {
		                    targetEl.classList.add("input-validation-error");
		                    targetEl.parentNode.querySelector(".errorMessage").textContent = response;
		                    targetEl.parentNode.querySelector(".errorMessage").classList.remove("hide");
		                    targetEl.focus();
		                },

				submitOrder = function () {
					formEvents.LoadPage();
					var creditCard;
					var panel = document.getElementById('ccPayInfo');
					var auth = "";
					var emptyGuid = "00000000-0000-0000-0000-000000000000";
					var requireCVVObj = document.getElementById('RequireExistingCardCvv');
					var requireCVV = "";

					if (requireCVVObj) {
						requireCVV = requireCVVObj.value.toLowerCase();
					}

					var authObj = document.getElementById("CreditCardAuth");
					if (authObj) {
						auth = authObj.value;
					}

					if (panel) {
						//copy cvv from text box into label cvv
						if (requireCVV === "true" && auth === "") {
							var a = panel.querySelectorAll("p");
							a[5].textContent = document.getElementById('SelectedCardCCV').value;
						}

						creditCard = paymentMethods.GetExistingCC("#ccPayInfo", true);
						if (!formEvents.VerifyCreditCardAuthorized(creditCard)) {
							formEvents.PutCreditCardInEditMode(creditCard.CardID, true);
							document.getElementById("btnSaveCreditCard").click();
							document.getElementById("btnPlaceOrder").disabled = false;
							return;
						}
					}

					var shipAddressId = addressMethods.GetExistingShipAddressId(document.getElementById('divSelectShipAddress'));
					if (!shipAddressId || shipAddressId === emptyGuid) {
						formEvents.PutShippingAddressInEditMode(cartId);
						document.getElementById("btnPlaceOrder").disabled = false;
						return;
					}

					var recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value.toString();
					var recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value.toString();
					var gurid = document.getElementById("CartModel_GURID").value.toString();
					var dateNeededBy = document.getElementById("CartModel_Cart_DateNeededBy")
						? document.getElementById("CartModel_Cart_DateNeededBy").value != "" 
							? document.getElementById("CartModel_Cart_DateNeededBy").value
							: null
						: null;

					// Ensure dateNeededBy is not in the past
					if (dateNeededBy) {
						let today = new Date();
						today.setHours(0, 0, 0, 0);

						const [year, month, day] = dateNeededBy.split('-');
						const selectedDate = new Date(Number(year), Number(month) - 1, Number(day));

						if (selectedDate < today) {
							showErrorValidation(document.getElementById("CartModel_Cart_DateNeededBy"), "Please select today or a future date.");
							formEvents.HideLoadPage();
							document.getElementById("btnPlaceOrder").disabled = false;
							return;
						}
					}

					grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
						let data = {
							CartId: cartId,
							TxtNotes: encodeURIComponent(document.getElementById("Cart_Notes").value),
							CardCcv: creditCard ? creditCard.CardCCV : "",
							CcError: creditCardErrorCount,
							CcAuth: auth,
							RecaptchaActionName: recaptchaActionName,
							RecaptchaToken: token,
							Gurid: gurid,
							CardId: panel ? creditCard.CardID : emptyGuid,
							ShipAddressId: shipAddressId,
							DateNeededBy: dateNeededBy,
							KaptchaSessionId: kaID
						};
						
						fetch('/checkout/submitorder', {
							method: 'POST',
							body: JSON.stringify(data),
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
						}).then(function (response) {
							return (response.ok) ? response.json() : [];
						}).then(function (response) {
							if (response) {
								response = parseAjaxResponse(response);
							}
							if (response.success) {
								window.location.href = "/orderconfirmation/" + response.oasisOrderID;
							} else {
								document.getElementById("btnPlaceOrder").disabled = false;

								if (response.partialView2) {
									formEvents.PutCreditCardInEditModeWithErrors(creditCard.CardID, true, response);
									++creditCardErrorCount;
								}
								else if (response.partialView1 === "y") {
									// missing shipping address 
									formEvents.PutShippingAddressInEditMode(cartId);
								}
								else {
									formEvents.HideLoadPage();
									
									if (response.notesInvalid) {
										showErrorValidation(document.getElementById("Cart_Notes"), response.message);
										return false;
									} else if (typeof response.message !== 'undefined' && response.message !== null) {
										formEvents.ShowAjaxMessage(response.message);
									} else {
										formEvents.ShowAjaxMessage("Your order could not be placed. Please refresh the page and try again.");
									}
								}
							}
						}).catch(function (error) {
							document.getElementById("btnPlaceOrder").disabled = false;
							formEvents.HideLoadPage();
							formEvents.ShowAjaxMessage(jsMessages.submitOrderError);
							++creditCardErrorCount;
						});
					});
				},

				saveCreditCard = function (creditCard) {

					let data = {
						PaymentMethod: creditCard,
						CartId: cartId,
						CcError: creditCardErrorCount
					};

					fetch('/checkout/savecreditcard', {
						method: 'POST',
						body: JSON.stringify(data),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						formEvents.HidePaymentLoad();
						if (response) {
							response = parseAjaxResponse(response);
						}

						if (response.success) {
							formEvents.UpdateShippingAddressList(response.partialView1);
							formEvents.UpdatePaymentMethods(response.partialView2, response.message);
							formEvents.UpdateCvv(creditCard.CardID, creditCard.CardCCV);
							document.getElementById("btnAddCC").parentNode.classList.remove('hide');
							document.getElementById("btnAddCC").setAttribute("aria-expanded", "false");
						} else {

							if (response.message.includes("cart not found") || response.message.includes("issues processing your card")) {
								document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = response.message;
								++creditCardErrorCount;
								return; // skip the additional error message below
							}

							document.getElementById("divCreditCardFormBlock").querySelector(".infoText").insertAdjacentHTML('afterbegin', errorMsgPanel);

							var errorId = "";

							if (response.error.includes("Billing address")) {
								errorId = "Address1";
							} else if (response.error.includes("Zipcode")) {
								errorId = "ZipCode";
							} else if (response.error.includes("card number")) {
								errorId = "CardNumber";
							} else if (response.error.includes("Expiration")) {
								errorId = "CardExpirationMonth";
							} else if (response.error.includes("Security code")) {
								errorId = "CardCCV";
							}

							document.getElementsByClassName("errorItem")[0].innerHTML = "<a href='#" + errorId + "'>" + response.error + "</a>";
							document.getElementById("ErrorBox").scrollIntoView({ behavior: "smooth" });

							if (response.partialView1 === "x") {
								formEvents.DisplayEditBillAddressForm();

								if (document.getElementById("divAddBillAddress").getElementsByClassName("divCancelSaveAddress")[0]) {
									document.getElementById("divAddBillAddress").getElementsByClassName("divCancelSaveAddress")[0].classList.add("hide");
									document.getElementById("divAddBillAddress").getElementsByClassName("divCancelSaveAddress")[0].classList.remove("inlineMiddle");
								}

								if (document.getElementById("btnCancelSaveAddress")) {
									document.getElementById("btnCancelSaveAddress").classList.remove("hide");
								}
							}

							++creditCardErrorCount;
						}
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = jsMessages.creditCardNotSaved;
						document.getElementById("CardName").focus();
						++creditCardErrorCount;
					});
				},

				saveBillingAddress = function (billAddress) {
					formEvents.LoadPayment();
					billAddress.AddressId = billAddress.AddressId === "" ? emptyGuid : billAddress.AddressId;
					billAddress.CartId = cartId;

					fetch('/checkout/savebillingaddress', {
						method: 'POST',
						body: JSON.stringify(billAddress),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response) {
							response = parseAjaxResponse(response);
						}
						if (response.success) {
							billAddress.AddressId = response.message;
							formEvents.UpdateShippingAddressList(response.partialView1);
							updatedBillingAddresses = response.partialView2;
							formEvents.UpdateBillingAddressList(updatedBillingAddresses);
							document.getElementById("btnNewBillAddress").setAttribute("aria-expanded", "false");
							// look for updated address
							var address = document.getElementById("divBillAddress_" + response.message).length ? addressMethods.GetExistingAddress("#divBillAddress_" + response.message, addressMethods.BillingAddressTypeId, true) : null;
							addressMethods.FillNewBillingAddress(address !== null ? address : billAddress);
							formEvents.BindBillingAddressListEvents();
							formEvents.ShowSelectedBilling();
							if (response.message === addressMethods.GetExistingShipAddressId(document.getElementById('divSelectShipAddress'))) {
								formEvents.UpdateSelectedShippingAddress(response.message);
							}
							addressMethods.FillForm(document.getElementById("divAddressFormBlock"), addressMethods.BlankAddress());
						} else {
							if (response.message.indexOf("ErrorMsgPanel") === -1) {
								document.getElementById("divAddressFormBlock").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', errorMsgPanel);
								document.getElementsByClassName("ErrorMsgPanel")[0].getElementsByClassName("errorItem")[0].innerHTML = response.message;
							}
							else {
								document.getElementById("divAddressFormBlock").querySelector(".infoText").innerHTML = response.message;
							}
							forms.serverValidation(document.getElementById("divAddressFormBlock").querySelector(".infoText"));
							if (document.getElementById("divAddressFormBlock").querySelector(".infoText").querySelector("a")) {
								document.getElementById("divAddressFormBlock").querySelector(".infoText").querySelector("a").focus();
							}
							document.getElementById("divAddressFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
						}
						formEvents.HideAjaxMessage();
						formEvents.HidePaymentLoad();
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						formEvents.ShowAjaxMessage(jsMessages.updateBillingAddressError);
					});
				},

				parseAjaxResponse = function (response) {
					const parser = new DOMParser();

					if (response.message) {
						response.message = parser.parseFromString(response.message, 'text/html');
						response.message = response.message.body.innerText;
					}

					if (response.partialView1) {
						response.partialView1 = parser.parseFromString(response.partialView1, 'text/html');
						response.partialView1 = response.partialView1.body.innerText;
					}

					if (response.partialView2) {
						response.partialView2 = parser.parseFromString(response.partialView2, 'text/html');
						response.partialView2 = response.partialView2.body.innerText;
					}

					return response;
				},

				registerAccount = function (shipAddress) {
					formEvents.LoadAddress();
					const recaptchaSiteKey = document.getElementById('RecaptchaSiteKey').value;
					const recaptchaActionName = document.getElementById('RecaptchaActionName').value;
					grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
						shipAddress.AddressId = shipAddress.AddressId ? shipAddress.AddressId : emptyGuid;
						shipAddress.CartId = shipAddress.CartId ? shipAddress.CartId : emptyGuid;

						fetch('/checkout/register', {
							method: 'POST',
							body: JSON.stringify({ LoginModel: login.GetFormData(token), AddressModel: shipAddress }),
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
						}).then(function (response) {
							return (response.ok) ? response.json() : [];
						}).then(function (response) {
							if (response) {
								response = parseAjaxResponse(response);
							}
							if (response.success) {
								omniture.ShipAddress();
								location.reload();
							} else {
								if (response.message.indexOf("ErrorMsgPanel") === -1) {
									document.getElementById("divNewShippingAddress").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', errorMsgPanel);
									document.getElementsByClassName("ErrorMsgPanel")[0].getElementsByClassName("errorItem")[0].innerHTML = response.message;
								}
								else {
									document.getElementById("divNewShippingAddress").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', response.message);
								}
								formEvents.CalculateDivShippingAddressHeight("#divNewShippingAddress");
							}
							formEvents.HideAjaxMessage();
							formEvents.HideAddressLoad();
						}).catch(function (error) {
							formEvents.CalculateDivShippingAddressHeight("#divNewShippingAddress");
							formEvents.HideAddressLoad();
							formEvents.ShowAjaxMessage(jsMessages.updateShippingAddressError);
						});
					});
				};

			return {
				AddCouponCode: addCouponCode,
				GetCreditCardIds: getCreditCardIds,
				DeleteCouponCode: deleteCouponCode,
				UpdateItemFreight: updateItemFreight,
				UpdateShippingAddress: updateShippingAddress,
				SubmitOrder: submitOrder,
				SaveShippingAddress: saveShippingAddress,
				SetPaymentMethod: setPaymentMethod,
				SetPaymentMethodInvoice: setPaymentMethodInvoice,
				SaveCreditCard: saveCreditCard,
				SaveBillingAddress: saveBillingAddress,
				ParseAjaxResponse: parseAjaxResponse,
				GetCCForm: getCCForm,
				get GetAddressForm() { return getAddressForm; },
				RegisterAccount: registerAccount
			};
		}()),

		omniture = (function () {
			var addCouponCode = function (couponCode) {
				const st = typeof s_gi === 'function' ? s_gi(s.account) : '';
				if (st) {
					st.linkTrackVars = 'eVar5,events';
					st.linkTrackEvents = 'event2';
					st.eVar5 = couponCode;
					st.events = 'event2';
					st.tl(true, 'o', 'Coupon Codes');
				}
			},
				shipAddress = function () {
					const st = typeof s_gi === 'function' ? s_gi(s.account) : '';
					if (st) {
						st.events = "event9";
						st.tl();
					}
				},
				shipMethod = function () {
					const st = typeof s_gi === 'function' ? s_gi(s.account) : '';
					if (st) {
						st.events = "event10";
						st.tl();
					}
				},

				registerMethod = function () {
					const st = typeof s_gi === 'function' ? s_gi(s.account) : '';
					if (st) {
						st.events = "event7";
						st.eVar4 = "Registration - In Order";
						st.tl();
					}
				};

			return {
				AddCouponCode: addCouponCode,
				ShipAddress: shipAddress,
				ShipMethod: shipMethod,
				RegisterMethod: registerMethod
			};
		}()),

		addressMethods = (function () {
			var shippingAddressTypeId = 1,
				billingAddressTypeId = 0,

				blankAddress = function () {
					return {
						AddressId: "",
						FirstName: "",
						LastName: "",
						CompanyName: "",
						Address1: "",
						Address2: "",
						City: "",
						State: "",
						ZipCode: "",
						Phone: "",
						Default: false,
						Active: true,
						AddressType: 0,
						LinkedAddress: false
					};
				},

				getExistingAddress = function (element, type, ignoreErrors) {
					if (document.querySelector(element)) {
						var a = document.querySelector(element).querySelectorAll("p");
						if (a.length < 10) {
							!ignoreErrors ? formEvents.ShowAjaxMessage(jsMessages.invalidAddressError) : true;
							return null;
						}

						var name = a[1].innerHTML.split("&nbsp;");
						if (name.length < 2) {
							!ignoreErrors ? formEvents.ShowAjaxMessage(jsMessages.invalidNameError) : true;
							return null;
						}

						var cityStateZip = a[5].innerHTML.split("&nbsp;");
						if (cityStateZip.length < 3 || cityStateZip[0].length < 2) {
							!ignoreErrors ? formEvents.ShowAjaxMessage(jsMessages.invalidCityError) : true;
							return null;
						}

						var addressObject = blankAddress();
						addressObject.AddressId = a[0].textContent.trim();
						addressObject.FirstName = name[0] ? name[0] : "";
						addressObject.LastName = name[1] ? name[1] : "";
						addressObject.CompanyName = a[2].textContent;
						addressObject.Address1 = a[3].textContent;
						addressObject.Address2 = a[4].textContent;
						addressObject.City = cityStateZip[0].length - 1 > 0 ? cityStateZip[0].substring(0, cityStateZip[0].length - 1) : "";
						addressObject.State = cityStateZip[1];
						addressObject.ZipCode = cityStateZip[2];
						addressObject.Phone = a[6].textContent;
						addressObject.Default = a[7].textContent.toLowerCase() === "true";
						addressObject.Active = a[8].textContent.toLowerCase() === "true";
						addressObject.LinkedAddress = a[9].textContent.toLowerCase() === "true";
						addressObject.AddressType = type;
						return addressObject;
					}
				},

				fillEditAddressForm = function (addressId) {
					var shipAddress = getExistingAddress("#divShipAddress_" + addressId, shippingAddressTypeId);
					if (shipAddress === null) {
						shipAddress = blankAddress();
					}
					fillForm(document.getElementById("divEditShipAddress_" + addressId), shipAddress);
				},

				fillEditBillingAddress = function () {
					var address = addressMethods.GetExistingAddress("#divBillAddress", billingAddressTypeId);
					if (address === null) {
						address = blankAddress();
					}

					fillForm(document.getElementById("divAddressFormBlock"), address);
				},

				fillAddAddressForm = function () {
					var shipAddress = blankAddress();
					shipAddress.AddressType = 1;
					fillForm(document.getElementById("divAddShipAddress"), shipAddress);
				},

				fillNewAddressForm = function () {
					var shipAddress = blankAddress();
					shipAddress.AddressType = 1;
					shipAddress.Default = true;
					fillForm(document.getElementById("divNewShippingAddress"), shipAddress);
				},

				fillForm = function (form, shipAddress) {
					form.querySelector("#AddressId").value = shipAddress.AddressId;
					form.querySelector("#FirstName").value = shipAddress.FirstName;
					form.querySelector("#LastName").value = shipAddress.LastName;
					form.querySelector("#CompanyName").value = shipAddress.CompanyName;
					form.querySelector("#Address1").value = shipAddress.Address1;
					form.querySelector("#Address2").value = shipAddress.Address2;
					form.querySelector("#City").value = shipAddress.City;
					form.querySelector("#State").value = shipAddress.State;
					form.querySelector("#ZipCode").value = shipAddress.ZipCode;
					form.querySelector("#Phone").value = removeNonNumeric(shipAddress.Phone);
					form.querySelector("#Default").checked = shipAddress.IsDefault;
					form.querySelector("#Active").value = shipAddress.Active;
					form.querySelector("#LinkedAddress").value = shipAddress.LinkedAddress;
					forms.MaskPhoneNumber(document.getElementsByClassName("PhoneMask")[0], document.getElementById("Phone"));
				},

				getEditShippingAddress = function (addressId, newCustomer) {
					var form;
					if (addressId.trim().length === 0) {
						if (newCustomer) {
							form = document.getElementById("divNewShippingAddress");
						} else {
							form = document.getElementById("divAddShipAddress");
						}
					} else {
						form = document.getElementById("divEditShipAddress_" + addressId);
					}
					return createAddressObject(form, shippingAddressTypeId);
				},

				removeNonNumeric = function (value) {
					return value.replace(/\D/g, '');
				},

				selectBillingAddress = function (element) {
					var selectAddress = element.querySelectorAll("p");
					var billAddress = document.getElementById("divBillAddress").querySelectorAll("p");
					if (selectAddress.length === billAddress.length) {
						for (var i = 0; i < selectAddress.length; i++) {
							billAddress[i].innerHTML = selectAddress[i].innerHTML;
						}
					} else {
						document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = jsMessages.invalidAddressError;
						document.getElementById("CardName").focus();
						document.getElementById("divCreditCardFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
					}
				},

				copySelectedShippingAddress = function () {
					var selectedShippingAddress = document.getElementById("divSelectShipAddress").querySelectorAll("p");
					var billAddress = document.getElementById("divBillAddress").querySelectorAll("p");
					if (selectedShippingAddress.length < 10 || selectedShippingAddress[0].innerHTML === '') {
						document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = jsMessages.invalidAddressError;
						document.getElementById("divCreditCardFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
					} else {
						for (var i = 0; i < 10; i++) {
							billAddress[i].innerHTML = selectedShippingAddress[i].innerHTML;
						}
					}
				},

				clearSelectedBillingAddress = function () {
					var billAddress = document.getElementById("divBillAddress").querySelectorAll("p");
					for (var i = 0; i < billAddress.length; i++) {
						billAddress[i].innerHTML = '';
					}
				},

				billingAndShippingAreSameID = function (bID, sID) {
					return sID.trim().length !== 0 && bID.trim().length !== 0 && bID === sID;
				},

				checkSetBillingAndShippingAreSameID = function () {
					var selectedShippingAddress = document.getElementById("divSelectShipAddress").querySelectorAll("p");
					var billAddress = document.getElementById("divBillAddress").querySelectorAll("p");
					return selectedShippingAddress[0].textContent.trim() === billAddress[0].textContent.trim();
				},

				getNewBillingAddress = function () {
					return createAddressObject(document.getElementById("divAddBillAddress"), billingAddressTypeId);
				},

				createAddressObject = function (form, type) {
					var addressObject = blankAddress();
					addressObject.AddressId = form.querySelector("#AddressId").value.trim();
					addressObject.FirstName = form.querySelector("#FirstName").value;
					addressObject.LastName = form.querySelector("#LastName").value;
					addressObject.CompanyName = form.querySelector("#CompanyName").value;
					addressObject.Address1 = form.querySelector("#Address1").value;
					addressObject.Address2 = form.querySelector("#Address2").value;
					addressObject.City = form.querySelector("#City").value;
					addressObject.State = form.querySelector("#State").value;
					addressObject.ZipCode = form.querySelector("#ZipCode").value;
					addressObject.Phone = form.querySelector("#Phone").value;
					if (form.querySelector("#Default")) {
						form.querySelector("#Default").value = form.querySelector("#Default").checked;
					}
					addressObject.Default = form.querySelector("#Default").value.toLowerCase() === "true";
					addressObject.Active = form.querySelector("#Active").value.toLowerCase() === "true";
					addressObject.LinkedAddress = form.querySelector("#LinkedAddress").value.toLowerCase() === "true";
					addressObject.AddressType = type;
					return addressObject;
				},

				fillNewBillingAddress = function (address) {
					var billAddress = document.getElementById("divBillAddress").querySelectorAll("p");
					copyBillingAddress(billAddress, address);
				},

				getExistingShipAddressId = function (element) {
					var a = element.querySelectorAll("p");
					return a[0] ? a[0].textContent.trim() : null;
				},

				updateSelectedBillingAddressOnChange = function (address) {
					if (address && document.getElementById("ccAddressSelected")) {
						var billAddress = document.getElementById("ccAddressSelected").querySelectorAll("p");
						if (address.AddressId === billAddress[0].textContent.trim()) {
							copyBillingAddress(billAddress, address);
						}
					}
				},

				copyBillingAddress = function (billAddress, address) {
					billAddress[0].innerHTML = address.AddressId;
					billAddress[1].innerHTML = address.FirstName + "&nbsp;" + address.LastName;
					billAddress[2].innerHTML = address.CompanyName;
					billAddress[3].innerHTML = address.Address1;
					billAddress[4].innerHTML = address.Address2;
					billAddress[5].innerHTML = address.City + ",&nbsp;" + address.State + "&nbsp;" + address.ZipCode;
					billAddress[6].innerHTML = address.Phone;
					billAddress[7].innerHTML = address.Default;
					billAddress[8].innerHTML = address.Active;
					billAddress[9].innerHTML = address.LinkedAddress;
				};

			return {
				BlankAddress: blankAddress,
				CopyBillingAddress: copyBillingAddress,
				GetExistingAddress: getExistingAddress,
				FillEditAddressForm: fillEditAddressForm,
				FillEditBillingAddress: fillEditBillingAddress,
				FillAddAddressForm: fillAddAddressForm,
				FillNewAddressForm: fillNewAddressForm,
				FillForm: fillForm,
				GetEditShippingAddress: getEditShippingAddress,
				get BillingAddressTypeId() { return billingAddressTypeId; },
				get ShippingAddressTypeId() { return shippingAddressTypeId; },
				SelectBillingAddress: selectBillingAddress,
				CopySelectedShippingAddress: copySelectedShippingAddress,
				ClearSelectedBillingAddress: clearSelectedBillingAddress,
				BillingAndShippingAreSameID: billingAndShippingAreSameID,
				CheckSetBillingAndShippingAreSameID: checkSetBillingAndShippingAreSameID,
				GetNewBillingAddress: getNewBillingAddress,
				FillNewBillingAddress: fillNewBillingAddress,
				GetExistingShipAddressId: getExistingShipAddressId,
				UpdateSelectedBillingAddressOnChange: updateSelectedBillingAddressOnChange
			};
		}()),

		paymentMethods = (function () {
			var blankCC = function () {
				return {
					Address: addressMethods.BlankAddress(),
					CardCCV: "",
					CardExpirationMonth: "",
					CardExpirationYear: "",
					CardID: "",
					CardName: "",
					CardNumber: "",
					CardPrefix: "",
					PaymentID: "",
					PaymentTypeID: -1,
					SavedName: "",
					IsDefault: false,
					PaymentDescription: "",
					IsSaved: false
				};
			},

				getExistingCC = function (element, ignoreErrors) {
					var a = document.querySelector(element).querySelectorAll("p");
					var ccObject = blankCC();
					ccObject.CardID = a[0].textContent.trim();
					ccObject.PaymentID = a[1].textContent.trim();
					ccObject.PaymentTypeID = parseInt(a[2].textContent);
					ccObject.CardName = forms.VerifyName(a[3].textContent);
					ccObject.PaymentDescription = a[4].textContent;
					ccObject.CardCCV = a[5].textContent;
					ccObject.SavedName = forms.VerifyName(a[6].textContent);
					ccObject.CardNumber = a[7].textContent;

					var expdate = a[8].textContent.split("/");
					ccObject.CardExpirationMonth = expdate[0];
					ccObject.CardExpirationYear = expdate[1];
					ccObject.IsAuthorized = a[9].textContent.toLowerCase() === "true";

					if (a.length < 20) {
						ignoreErrors = !ignoreErrors ? formEvents.ShowAjaxMessage(jsMessages.invalidAddressError) : true;
						return ccObject;
					}

					// get cc address
					var ccAddressObject = addressMethods.GetExistingAddress("#ccAddress_" + ccObject.CardID, addressMethods.BillingAddressTypeId);
					if (ccAddressObject === null) {
						return ccObject;
					}

					// look for updated address
					var addressObject = addressMethods.GetExistingAddress("#divBillAddress_" + ccAddressObject.AddressId, addressMethods.BillingAddressTypeId, true);
					var valid = !!addressObject;

					ccObject.Address.FirstName = valid ? addressObject.FirstName : ccAddressObject.FirstName;
					ccObject.Address.LastName = valid ? addressObject.LastName : ccAddressObject.LastName;
					ccObject.Address.CompanyName = valid ? addressObject.CompanyName : ccAddressObject.CompanyName;
					ccObject.Address.Address1 = valid ? addressObject.Address1 : ccAddressObject.Address1;
					ccObject.Address.Address2 = valid ? addressObject.Address2 : ccAddressObject.Address2;
					ccObject.Address.City = valid ? addressObject.City : ccAddressObject.City;
					ccObject.Address.State = valid ? addressObject.State : ccAddressObject.State;
					ccObject.Address.ZipCode = valid ? addressObject.ZipCode : ccAddressObject.ZipCode;
					ccObject.Address.Phone = valid ? addressObject.Phone : ccAddressObject.Phone;
					ccObject.Address.IsDefault = ccAddressObject.IsDefault;
					ccObject.Address.AddressId = ccAddressObject.AddressId;
					ccObject.Address.IsSaved = ccAddressObject.LinkedAddress;

					formEvents.HideAjaxMessage();
					return ccObject;
				},

				fillEditCCForm = function (cardId) {
					var cCard = getExistingCC("#divPaymentMethod_" + cardId);
					var form = document.getElementById("divEditCC_" + cardId);
					fillForm(form, cCard);
					form.querySelector('#CardNumber').disabled = true;
					form.querySelector('#IsSaved').disabled = true;
					if (!form.querySelector("#IsSaved").checked) {
						form.querySelector("#SavedName").parentNode.classList.add("hide");
						form.querySelector("#IsDefault").parentNode.classList.add("hide");
					}
					if (form.querySelector("#divBillAddress").querySelectorAll("p")[0].textContent.length > 0) {
						form.querySelector("#divBillAddress").classList.remove('hide');
					}
					forms.MaskCVVNumber(document.getElementById("CvvMask"), document.getElementById("CardCCV"));
				},

				fillAddCCForm = function () {
					var cCard = blankCC();
					var form = document.getElementById("divAddCCForm");
					fillForm(form, cCard);
					form.querySelector('#IsSaved').checked = true;
					form.querySelector('#IsDefault').checked = true;
					if (!form.querySelector("#IsSaved").checked) {
						form.querySelector("#SavedName").parentNode.classList.add("hide");
						form.querySelector("#IsDefault").parentNode.classList.add("hide");
					}
					forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
					forms.MaskCVVNumber(document.getElementById("CvvMask"), document.getElementById("CardCCV"));
				},

				fillNewCCForm = function () {
					var cCard = blankCC();
					var form = document.getElementById("divNewPaymentMethod");
					fillForm(form, cCard);
					form.querySelector('#IsSaved').checked = true;
					form.querySelector("#IsDefault").checked = true;
					if (!form.querySelector("#IsSaved").checked) {
						form.querySelector("#SavedName").parentNode.classList.add("hide");
						form.querySelector("#IsDefault").parentNode.classList.add("hide");
					}
					forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
					forms.MaskCVVNumber(document.getElementById("CvvMask"), document.getElementById("CardCCV"));
				},

				fillForm = function (form, cCard) {
					form.querySelector("#CardID").value = cCard.CardID;
					form.querySelector("#PaymentID").value = cCard.PaymentID;
					form.querySelector("#IsDefault").checked = cCard.IsDefault;
					form.querySelector("#SavedName").value = forms.VerifyName(cCard.SavedName);
					form.querySelector("#IsSaved").checked = cCard.IsSaved;
					form.querySelector("#CardNumber").value = cCard.CardNumber;
					form.querySelector("#PaymentTypeID").value = cCard.PaymentTypeID;
					form.querySelector("#CardExpirationMonth").value = cCard.CardExpirationMonth;
					form.querySelector("#CardExpirationYear").value = cCard.CardExpirationYear;
					form.querySelector("#CardName").value = forms.VerifyName(cCard.CardName);
					form.querySelector("#PaymentTypeID").value = cCard.PaymentTypeID;
					form.querySelector("#CardCCV").value = cCard.CardCCV;
					form.querySelector("#IsAuthorized").value = cCard.IsAuthorized;
					form.querySelector("#PaymentDescription").value = cCard.PaymentDescription;

					var billaddress = form.querySelector("#divBillAddress").querySelectorAll("p");
					if (billaddress[0]) {
						addressMethods.CopyBillingAddress(billaddress, cCard.Address);
					}

					var shipaddressId = addressMethods.GetExistingShipAddressId(document.getElementById('divSelectShipAddress'));
					if (shipaddressId && addressMethods.BillingAndShippingAreSameID(cCard.Address.AddressId, shipaddressId)) {
						form.querySelector('#UseShippingAddress').checked = true;
					} else {
						form.querySelector('#UseShippingAddress').checked = false;
					}
					forms.MaskPhoneNumber(document.getElementsByClassName("PhoneMask")[0], document.getElementById("Phone"));
				},

				setPaymentMethod = function (element) {
					formEvents.ClearPaymentMethodError();
					var cardId = element.getAttribute("data-card-id");
					if (formEvents.VerifyCreditCardAuthorized(getExistingCC("#divPaymentMethod_" + cardId))) {
						if (document.getElementById("divSelectPaymentMethod").querySelector("p").textContent === cardId) {
							formEvents.PaymentMethodEditMode = false;
							formEvents.PaymentMethodDefaultMode();
							return;
						} else {
							ajaxActions.SetPaymentMethod(cardId);
						}
					} else {
						formEvents.PutCreditCardInEditMode(cardId);
					}
				},

				getEditCC = function (cardId, newCustomer) {
					var form;
					if (cardId.trim().length === 0) {
						if (newCustomer) {
							form = document.getElementById("divNewPaymentMethod");
						} else {
							form = document.getElementById("divAddCCForm");
						}
					} else {
						form = document.getElementById("divEditCC_" + cardId);
					}

					var ccObject = blankCC();
					ccObject.CardID = form.querySelector("#CardID").value;
					ccObject.PaymentID = form.querySelector("#PaymentID").value;
					ccObject.PaymentTypeID = parseInt(form.querySelector("#PaymentTypeID").value);
					ccObject.PaymentDescription = form.querySelector("#PaymentDescription").value;
					ccObject.IsAuthorized = form.querySelector("#IsAuthorized").value.toLowerCase() === "true" ? true : false;

					// ignore ccv if not using micro-service
					ccObject.CardCCV = form.querySelector("#CardCCV").getAttribute("type") === "hidden" ? "000" : form.querySelector("#CardCCV").value;

					//if the cardnumber is masked, return the non-masked cardnumber, otherwise just the value
					ccObject.CardNumber = form.querySelector("#CardNumber").value;
					ccObject.CardExpirationMonth = form.querySelector("#CardExpirationMonth").value;
					ccObject.CardExpirationYear = form.querySelector("#CardExpirationYear").value;
					ccObject.CardName = forms.VerifyName(form.querySelector("#CardName").value);
					ccObject.IsDefault = form.querySelector("#IsDefault").checked === true ? true : false;
					ccObject.IsSaved = form.querySelector("#IsSaved").checked === true ? true : false;
					ccObject.SavedName = ccObject.IsSaved && form.querySelector("#SavedName").value ? forms.VerifyName(form.querySelector("#SavedName").value) : forms.GetCreditCardName(ccObject.CardNumber);
					ccObject.Address = addressMethods.GetExistingAddress("#divBillAddress", addressMethods.BillingAddressTypeId);
					return ccObject;
				};

			return {
				SetPaymentMethod: setPaymentMethod,
				FillEditCCForm: fillEditCCForm,
				FillAddCCForm: fillAddCCForm,
				FillNewCCForm: fillNewCCForm,
				GetEditCC: getEditCC,
				GetExistingCC: getExistingCC
			};
		}()),

		formEvents = (function () {
			var paymentMethodEditMode = false;
			var errMode = false;
			var errResponse = "";
			var displayFlag = false;
			var loadingIcon = '<div id="checkoutLoading" class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			var shipAddressHeight = 0,

				hideBusy = function () {
					if (document.getElementById("showLoading")) {
						document.getElementById("showLoading").parentNode.removeChild(document.getElementById("showLoading"));
					}
				},

				loadPage = function () {
					document.getElementById("loadPage").classList.remove("hide");
					document.getElementById("loadPage").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				loadCoupon = function () {
					document.getElementById("loadSummaryBox").classList.remove("hide");
					document.getElementById("loadSummaryBox").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				loadAddress = function () {
					document.getElementById("loadingStep1").classList.remove("hide");
					document.getElementById("loadingStep1").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				loadFreight = function () {
					document.getElementById("loadingStep2").classList.remove("hide");
					document.getElementById("loadingStep2").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				loadPayment = function () {
					document.getElementById("loadingStep3").classList.remove("hide");
					document.getElementById("loadingStep3").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				hideLoadPage = function () {
					document.getElementById("loadPage").classList.add("hide");
					document.getElementById("loadPage").querySelector(".busyIndicator").innerHTML = "";
				},

				hideLoadCoupon = function () {
					document.getElementById("loadSummaryBox").classList.add("hide");
					document.getElementById("loadSummaryBox").querySelector(".busyIndicator").innerHTML = "";
				},

				hideAddressLoad = function () {
					document.getElementById("loadingStep1").classList.add("hide");
					document.getElementById("loadingStep1").querySelector(".busyIndicator").innerHTML = "";
				},

				hideFreightLoad = function () {
					document.getElementById("loadingStep2").classList.add("hide");
					document.getElementById("loadingStep2").querySelector(".busyIndicator").innerHTML = "";
				},

				hidePaymentLoad = function () {
					document.getElementById("loadingStep3").classList.add("hide");
					document.getElementById("loadingStep3").querySelector(".busyIndicator").innerHTML = "";
				},

				bindAddressAutoComplete = function () {
					maps.BindAddressAutoCompleteEvents();
				},

				showEnterCouponCode = function (e) {
					e.preventDefault();
					document.getElementById("btnEnterCouponCode").setAttribute("aria-expanded", "true");
					document.getElementById("btnEnterCouponCode").classList.add("hide");
					document.getElementById("divCouponCode").classList.remove("hide");
					document.getElementById("txtCouponCode").focus();
				},

				submitCouponCode = function (e) {
					e.preventDefault();
					var couponCode = document.getElementById("txtCouponCode").value.toUpperCase();
					if (couponCode) {
						document.getElementById("txtCouponCode").classList.add("txtReq");
						ajaxActions.AddCouponCode(couponCode);
					} else {
						couponCodeError(jsMessages.couponError);
					}
				},

				couponCodeError = function (errMsg) {
					document.getElementById("txtCouponCode").classList.add("input-validation-error");
					document.getElementById("couponCodeError").textContent = errMsg;
					document.getElementById("txtCouponCode").setAttribute("aria-invalid", "true");
					document.getElementById("txtCouponCode").focus();
				},

				hideEnterCouponCode = function () {
					document.getElementById("btnEnterCouponCode").setAttribute("aria-expanded", "false");
					document.getElementById("btnEnterCouponCode").classList.remove("hide");
					document.getElementById("btnEnterCouponCode").focus();
					document.getElementById("divCouponCode").classList.add("hide");
					document.getElementById("txtCouponCode").classList.remove("input-validation-error");
					document.getElementById("txtCouponCode").removeAttribute("aria-invalid");
					document.getElementById("txtCouponCode").value = "";
					document.getElementById("couponCodeError").textContent = "";
				},

				addCouponCode = function (data, code) {
					if (!data.itemCount) {
						reloadPage();
					} else {
						hideLoadCoupon();
						document.getElementById("removeCouponCode").setAttribute("title", document.getElementById("removeCouponCode").getAttribute("title") + code);
						document.getElementById("removeCouponCode").setAttribute("data-coupon-code", code);
						document.getElementById("couponApplied").innerHTML = code + document.getElementById("couponApplied").innerHTML;
						updateCartTotals(data);
						hideEnterCouponCode();
						document.getElementById("divShowCouponCodes").classList.remove("hide");
						checkCartHasCoupon();
						updateHeaderCartSummary(data);
						document.getElementById("removeCouponCode").focus();
					}
				},

				deleteCouponCode = function (data, code) {
					if (!data.itemCount) {
						reloadPage();
					} else {
						hideLoadCoupon();
						var couponTitle = document.getElementById("removeCouponCode").getAttribute("title").replace(code, "");
						var couponHTML = document.getElementById("couponApplied").innerHTML.replace(code, "");
						document.getElementById("divShowCouponCodes").classList.add("hide");
						document.getElementById("removeCouponCode").setAttribute("title", couponTitle);
						document.getElementById("removeCouponCode").setAttribute("data-coupon-code", "");
						document.getElementById("removeCouponCode").innerHTML = document.getElementById("removeCouponCode").innerHTML.replace(code, "");
						document.getElementById("couponApplied").innerHTML = couponHTML;
						updateCartTotals(data);
						checkCartHasCoupon();
						updateHeaderCartSummary(data);
						document.getElementById("btnEnterCouponCode").focus();
					}
				},

				reloadPage = function () {
					location.reload();
				},

				checkCartHasCoupon = function () {
					if (document.getElementById("divShowCouponCodes")) {
						if (document.getElementById("divShowCouponCodes").classList.contains("hide")) {
							document.getElementById("btnEnterCouponCode").classList.remove("hide");
						} else {
							document.getElementById("btnEnterCouponCode").classList.add("hide");
						}
					}
				},

				updateHeaderCartSummary = function (data) {
					if (data.partialView1) {
						document.querySelector(".cartSummaryContainer").innerHTML = data.partialView1;
						// re-hookup hover event -- currently in header2018.js
						var headerLinks = new header4i();
						headerLinks.init_cartsummary();
					}
				},

				showPaymentOptions = function (payid) {
					if (payid === 'ccpayopt') {
						formEvents.ShowPaymentMethodPanel();
						document.getElementById('divOtherPayOptions').classList.add('hide');
					} else {
						document.getElementById('divCCPayOptions').classList.add('hide');
						document.getElementById('divOtherPayOptions').classList.remove('hide');
						document.getElementById('divNewPaymentMethod').classList.add('hide');
						hidePaymentLoad();
					}
				},

				showLineOfCreditInfo = function (e) {
					e.preventDefault();
					document.getElementById('divBillMeBtn').classList.add('hide');
					document.getElementById('divBillMeInfo').classList.remove('hide');
				},

				resetBillMeLater = function () {
					document.getElementById('divNewPaymentMethod').classList.remove('hide');
					document.getElementById('divOtherPayOptions').classList.add('hide');
				},

				updateCartTotals = function (data) {
					document.querySelector(".cartItemCount").innerHTML = data.itemCount;
					document.querySelector(".cartSubtotal").innerHTML = data.subTotal;
					document.querySelector(".cartFreightTotal").innerHTML = data.totalFreight;
					document.querySelector(".cartTax").innerHTML = data.tax;
					var cartTotals = [].slice.call(document.querySelectorAll(".cartTotal"));
					cartTotals.forEach(function (el, index, array) {
						el.innerHTML = data.cartTotal;
					});
					if (document.querySelector("#couponDiscountAmount")) {
						document.querySelector("#couponDiscountAmount").innerHTML = data.couponTotal;
					}
				},

				showAjaxMessage = function (msg) {
					document.getElementById("divNotification").innerHTML = msg;
					document.getElementById("divNotification").classList.remove("hide");
					document.getElementById("divNotification").focus();
					window.scrollTo({ top: 0, behavior: "smooth" });
				},

				hideAjaxMessage = function () {
					if (document.getElementById("divNotification")) {
						document.getElementById("divNotification").classList.add("hide");
					}
				},

				markShippingAddressComplete = function () {
					document.getElementById("editShippingAddress").classList.remove("hide");
					document.getElementById("shipAddressStatus").innerHTML = "<div class='textTeal'><svg height='25px' width='25px' aria-label='Shipping address complete'><use xlink:href='#svgIcon-checkMark'></use> </svg></div>";
					document.getElementById("shipAddressStatus").classList.remove("textBlue");
					document.getElementById("shipAddressStatus").classList.add("textTeal");
					document.getElementById("shipMethodStatus").innerHTML = "<div class='textTeal'><svg height='25px' width='25px' aria-label='Shipping method complete'><use xlink:href='#svgIcon-checkMark'></use> </svg></div>";
					document.getElementById("shipMethodStatus").classList.remove("textBlue");
					document.getElementById("shipMethodStatus").classList.add("textTeal");
					document.getElementById("divShippingMethodItems").classList.remove("hide");
				},

				markPaymentMethodComplete = function () {
					document.getElementById("editPaymentMethod").classList.remove("hide");
					document.getElementById("paymentMethodStatus").innerHTML = "<div class='textTeal'><svg height='25px' width='25px' aria-label='Payment method complete'><use xlink:href='#svgIcon-checkMark'></use> </svg></div>";
					document.getElementById("paymentMethodStatus").classList.remove("textBlue");
					document.getElementById("paymentMethodStatus").classList.add("textTeal");
				},
				updateView = function () {
					var showReviewOrder = true;

					if (!document.getElementById("divSelectShipAddress").classList.contains("hide")) {
						if (addressMethods.GetExistingShipAddressId(document.getElementById("divSelectShipAddress")).length > 0) {
							markShippingAddressComplete();
							showReviewOrder = showReviewOrder && true;
						} else {
							// no shipping address selected - prompt for one
							shippingAddressEditMode();
							return;
						}
					} else {
						document.getElementById("editShippingAddress").classList.add("hide");
						document.getElementById("shipAddressStatus").innerHTML = document.getElementById("shipAddressStatus").innerHTML;
						document.getElementById("shipAddressStatus").classList.add("textBlue");
						document.getElementById("shipAddressStatus").classList.remove("textTeal");
						document.getElementById("shipMethodStatus").innerHTML = document.getElementById("shipMethodStatus").innerHTML;
						document.getElementById("shipMethodStatus").classList.add("textBlue");
						document.getElementById("shipMethodStatus").classList.remove("textTeal");
						document.getElementById("divShippingMethodItems").classList.add("hide");
						showReviewOrder = showReviewOrder && false;
					}

					if (!document.getElementById("divNewShippingAddress").classList.contains("hide")) {
						document.getElementById("shipMethodStatus").innerHTML = document.getElementById("shipMethodStatus").innerHTML;
						document.getElementById("shipMethodStatus").classList.add("textBlue");
						document.getElementById("shipMethodStatus").classList.remove("textTeal");
						document.getElementById("divShippingMethodItems").classList.add("hide");
					}

					document.getElementById("divShippingAddress").classList.remove("hide");
					paymentMethodEditingMode();

					if (!document.getElementById("divSelectPaymentMethod").classList.contains("hide")) {
						markPaymentMethodComplete();
						if (document.getElementById("SelectedCardCCV")) {
							forms.MaskCVVNumber(document.getElementById("selectedCvvMask"), document.getElementById("SelectedCardCCV"));
						}
						showReviewOrder = showReviewOrder && true;
					} else {
						document.getElementById("editPaymentMethod").classList.add("hide");
						document.getElementById("paymentMethodStatus").innerHTML = document.getElementById("paymentMethodStatus").innerHTML;
						document.getElementById("paymentMethodStatus").classList.add("textBlue");
						document.getElementById("paymentMethodStatus").classList.remove("textTeal");
						showReviewOrder = showReviewOrder && false;
					}

					document.getElementById("divPaymentMethod").classList.remove("hide");
					if (showReviewOrder) {
						document.getElementsByClassName("reviewOrderTotal")[0].classList.remove("hide");
					} else {
						document.getElementsByClassName("reviewOrderTotal")[0].classList.add("hide");
					}
				},

				shippingAddressEditMode = function () {
					formEvents.PaymentMethodEditMode = false;
					document.getElementById("divSelectShipAddress").classList.add("hide");
					document.getElementById("divListShipAddress").classList.remove("hide");
					document.getElementById("divListShipAddress").getElementsByTagName("button")[0].focus();
					if (document.getElementById("divNewPaymentMethod")) {
						document.getElementById("divNewPaymentMethod").classList.add("hide");
					}
					clearShippingAddressError();
					removeShippingAddressError();
					updateView();
				},

				paymentMethodEditingMode = function () {
					var hiddenBills;
					if (paymentMethodEditMode) {
						document.getElementById("divSelectPaymentMethod").classList.add("hide");
						document.getElementById("divListPaymentMethod").classList.remove("hide");
						if (document.getElementById("divSelectPaymentMethod").querySelector("p").innerHTML.indexOf("invoice") !== -1) {
							document.getElementById("otherpayopt").checked = true;
							document.getElementById("divOtherPayOptions").classList.remove("hide");
							document.getElementsByClassName("creditcardimages")[0].classList.add("hide");
						}
						var payMethodRadios = [].slice.call(document.getElementById("divListPaymentMethod").querySelectorAll('input[type=radio]'));
						var selectedMethods = [];
						payMethodRadios.forEach(function (el, index, array) {
							if (el.checked) {
								selectedMethods.push(el);
							}
						});
						selectedMethods[0].focus();

						if (parseInt(document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : "") !== 0 || formEvents.displayFlag) {
							formEvents.ShowPaymentMethodPanel();
						}

						if (document.getElementById("otherpayopt").checked) {
							document.getElementById("divNewPaymentMethod").classList.add("hide");
							document.getElementById("divCCPayOptions").classList.add("hide");
						}
						hiddenBills = [].slice.call(document.querySelectorAll(".hiddenpaybill"));
						hiddenBills.forEach(function (el, index, array) {
							el.classList.add("hide");
						});
						clearPaymentMethodError();
						removePaymentMethodError();
						document.getElementById("divSelectShipAddress").classList.remove("hide");
						document.getElementById("divListShipAddress").classList.add("hide");
						document.getElementById("divNewShippingAddress").classList.add("hide");
						markShippingAddressComplete();
						closeOpenEdits();

					} else {
						var addressEditMode = document.getElementById("divSelectShipAddress").classList.contains("hide");

						// these are generally for when it is a first time user
						if (document.getElementById('divSelectPaymentMethod').innerHTML.trim().length !== 0 && !addressEditMode) {
							var panel = document.getElementById('ccPayInfo');
							var creditCard = panel ? paymentMethods.GetExistingCC("#ccPayInfo", true) : undefined;
							if (!creditCard || verifyCreditCardAuthorized(creditCard)) {
								document.getElementById("divSelectPaymentMethod").classList.remove("hide");
								hiddenBills = [].slice.call(document.getElementById("divSelectPaymentMethod").querySelectorAll(".hiddenpaybill"));
								hiddenBills.forEach(function (el, index, array) {
									el.classList.remove("hide");
								});
								document.getElementById("divListPaymentMethod").classList.add("hide");
								document.getElementById("divNewPaymentMethod").classList.add("hide");
								closeOpenEditsCC();
							} else {
								paymentMethodEditMode = true;
								paymentMethodEditingMode();
								document.getElementById("editShippingAddress").focus();
								document.getElementById("editShippingAddress").scrollIntoView({ top: 0, behavior: "smooth" });
								return;
							}
						} else {
							// make sure shipping address isn't being edited
							if (!addressEditMode) {
								var numberOfCCs = document.getElementById("PaymentMethods_Count").value;
								if (parseInt(numberOfCCs) === 0) {
									document.getElementById('divCCPayOptions').classList.add('hide');
									document.getElementById("divNewPaymentMethod").classList.remove("hide");
								} else {
									document.getElementById("divNewPaymentMethod").classList.add("hide");
									document.getElementById("divCCPayOptions").classList.remove('hide');
								}
								document.getElementById("divListPaymentMethod").classList.remove('hide');
							} else {
								document.getElementById("divListPaymentMethod").classList.add('hide');
								closeOpenEditsCC();
							}
						}
					}
					if (paymentMethodEditMode || document.getElementById("divSelectShipAddress").classList.contains("hide")) {
						document.getElementById("editPaymentMethod").classList.add("hide");
					} else {
						document.getElementById("editPaymentMethod").classList.remove("hide");
					}
				},

				paymentMethodDefaultMode = function () {
					document.getElementById("divSelectPaymentMethod").classList.remove("hide");
					var hiddenBills = [].slice.call(document.getElementById("divSelectPaymentMethod").querySelectorAll(".hiddenpaybill"));
					hiddenBills.forEach(function (el, index, array) {
						el.classList.remove("hide");
					});
					document.getElementById("divListPaymentMethod").classList.add("hide");
					updateView();
					document.getElementById("editPaymentMethod").focus();
					document.getElementById("editPaymentMethod").scrollIntoView({ top: 0, behavior: "smooth" });
					closeOpenEditsCC();
				},

				updatePaymentMethods = function (ccList, message) {
					// update address list first before updating selected address
					document.getElementById("divListPaymentMethod").innerHTML = ccList;
					bindPaymentMethodEvents();
					document.getElementById("divSelectPaymentMethod").innerHTML = message;
					if (document.getElementsByClassName("ccDisplay")[0]) {
						formEvents.displayFlag = document.getElementsByClassName("ccDisplay")[0].innerHTML === "" ? true : false;
					}
					formEvents.PaymentMethodEditMode = false;
					paymentMethodDefaultMode();
				},

				updateCvv = function (cardId, cvv) {
					var a = document.getElementById("ccPayInfo").querySelectorAll("p");
					if (a.length > 5) {
						a[5].textContent = cvv;
					}

                    if(pendingSubmitAfterCCSave) {
                        pendingSubmitAfterCCSave = false;
                        forms.formValidation(document.getElementById("divListPaymentMethod"), ajaxActions.SubmitOrder);
                    }
				},

				updatePaymentMethodInvoice = function () {
					document.getElementById("divSelectPaymentMethod").innerHTML = jsMessages.invoicePaymentLabel;
					formEvents.PaymentMethodEditMode = false;
					paymentMethodDefaultMode();
				},

				shippingAddressDefaultMode = function () {
					document.getElementById("divSelectShipAddress").classList.remove("hide");
					document.getElementById("divListShipAddress").classList.add("hide");
					document.getElementById("divNewShippingAddress").classList.add("hide");
					updateView();
					document.getElementById("editShippingAddress").focus();
					document.getElementById("editShippingAddress").scrollIntoView({ top: 0, behavior: "smooth" });
					closeOpenEdits();
				},

				updateShippingAddress = function (addressList, addressId) {
					// update address list first before updating selected address
					document.getElementById("divListShipAddress").innerHTML = addressList;
					bindShipAddressEvents();
					updateSelectedShippingAddress(addressId);
					shippingAddressDefaultMode();
				},

				updateSelectedShippingAddress = function (addressId) {
					document.getElementById("divSelectShipAddress").innerHTML = document.getElementById("divShipAddress_" + getShippingAddressId(addressId)).innerHTML;
				},

				updateShippingMethods = function (freightItems) {
					document.getElementById("divShippingMethodItems").innerHTML = freightItems;
					bindShipMethodEvents();
				},

				getShippingAddressId = function (addressId) {
					if (addressId.trim().length !== 0) {
						return addressId;
					}
					var div = document.getElementById("divListShipAddress").querySelector(".selected");
					if (div) {
						var ids = div.id.split("_");
						if (ids.length === 2) {
							return ids[1];
						}
					}
					return "";
				},

				showNewAddressForm = function () {
					document.getElementById("divNewShippingAddress").classList.remove("hide");
					const element = document.getElementById("FirstName");

					if (document.getElementById("btnSaveAddress")) {
						document.getElementById("btnSaveAddress").classList.add("BtnSubmitForm");  // for form abandonment
					}

					if (element) {
						element.click();  // for form abandonment
						element.focus();
					}

					if (document.getElementById("Phone")) {
						document.getElementById("Phone").addEventListener("paste", function (e) {
							forms.FixPastedPhoneNumber(e, document.getElementsByClassName("PhoneMask")[0]);
						});
					}

					if (login.GetLoginStatus === loginStatuses.AccountSetup && document.getElementById("divAddressDefault")) {
						// for new customer force entered address to be default seeing it is only address available
						document.getElementById("divAddressDefault").classList.add("hide");
						omniture.RegisterMethod();
					}
				},

				updateShippingAddressError = function (msg, addressId) {
					var editButtons = document.querySelectorAll(".btnEditShipAddress");
					var found = false;
					for (var i = 0; i < editButtons.length; i++) {
						if (editButtons[i].hasAttribute("data-ship-address-id") && editButtons[i].getAttribute("data-ship-address-id") === addressId) {
							editButtons[i].click();
							document.querySelector(".infoTextMain").innerHTML = msg;
							forms.serverValidation(document.querySelector(".infoTextMain"));
							if (document.querySelector(".infoTextMain").querySelector("a")) {
								document.querySelector(".infoTextMain").querySelector("a").focus();
							}
							document.querySelector(".infoTextMain").scrollIntoView({ top: 0, behavior: "smooth" });
							calculateDivShippingAddressHeight("#divEditShipAddress_" + addressId);
							found = true;
							break;
						}
					}

					if (!found) {
						document.querySelector(".infoTextMain").innerHTML = msg;
						forms.serverValidation(document.querySelector(".infoTextMain"));
						if (document.querySelector(".infoTextMain").querySelector("a")) {
							document.querySelector(".infoTextMain").querySelector("a").focus();
						}
						document.querySelector(".infoTextMain").scrollIntoView({ top: 0, behavior: "smooth" });
					}
				},

				savingShippingAddressError = function (msg, addressId) {
					var infoText = document.querySelector(".infoTextMain");
					if (infoText.length) {
						infoText.innerHTML = msg;
						forms.serverValidation(infoText);
						if (infoText.querySelector("a")) {
							infoText.querySelector("a").focus();
						}
						infoText.scrollIntoView({ top: 0, behavior: "smooth" });
					} else {
						updateShippingAddressError(msg, addressId);
					}
				},

				clearShippingAddressError = function () {
					hideAjaxMessage();
					if (document.querySelector(".infoTextMain")) {
						document.querySelector(".infoTextMain").innerHTML = "";
					}
				},

				clearPaymentMethodError = function () {
					if (document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod")) {
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").innerHTML = "";
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").classList.remove("paddingTop5");
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").classList.remove("paddingBtm15");
					}
				},

				settingPaymentMethodError = function (msg) {
					if (document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod")) {
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").innerHTML = msg;
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").scrollIntoView({ top: 0, behavior: "smooth" });
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").classList.add("paddingTop5");
						document.getElementById("divListPaymentMethod").querySelector(".infoTextPmtMethod").classList.add("paddingBtm15");
					}
				},

				removeShippingAddressError = function () {
					if (document.querySelector(".infoTextMain")) {
						document.querySelector(".infoTextMain").innerHTML = "";
					}
				},

				bindPaymentMethodEvents = function () {
					var paymentOpts = [].slice.call(document.querySelectorAll("input[name='payoptions']"));
					paymentOpts.forEach(function (el, index, array) {
						el.addEventListener("click", function (e) {
							formEvents.LoadPayment();
							formEvents.ClearPaymentMethodError();
							document.getElementById("btnAddCC").parentNode.classList.remove('hide');
							if (el.checked && el.id === "ccpayopt") {
								document.getElementById("divListPaymentMethod").getElementsByClassName("creditcardimages")[0].classList.remove("hide");
							}
							else {
								var ccImgs = [].slice.call(document.querySelectorAll(".creditcardimages"));
								ccImgs.forEach(function (el, index, array) {
									el.classList.add("hide");
								});
							}
							formEvents.ShowPaymentOptions(el.id);
						});
						if (el.checked && el.id === "ccpayopt") {
							formEvents.ShowPaymentOptions(el.id);
						}
					});

					var payWithCC = function (e) {
						e.preventDefault();
						document.getElementById("btnAddCC").parentNode.classList.remove('hide');
						document.getElementsByClassName("creditcardimages")[0].classList.remove("hide");
						formEvents.LoadPayment();
						document.getElementById("ccpayopt").click();
					};
					if (document.getElementById("btnLOCPayWithCC")) {
						document.getElementById("btnLOCPayWithCC").removeEventListener("click", payWithCC);
						document.getElementById("btnLOCPayWithCC").addEventListener("click", payWithCC);
					}

					var proceed = function (e) {
						e.preventDefault();
						document.getElementById("divNewPaymentMethod").classList.add("hide");
						document.getElementById("divCCPayOptions").classList.add("hide");
						forms.ClearValidation();
						ajaxActions.SetPaymentMethodInvoice();
					};
					if (document.getElementById('btnProceed')) {
						document.getElementById('btnProceed').removeEventListener("click", proceed);
						document.getElementById('btnProceed').addEventListener("click", proceed);
					}

					if (document.getElementById("btnAddCC")) {
						document.getElementById("btnAddCC").removeEventListener("click", formEvents.AddCreditCard);
						document.getElementById("btnAddCC").addEventListener("click", formEvents.AddCreditCard);
					}

					var usePayment = function (e) {
						e.preventDefault();
						var el = e.currentTarget;
						forms.ClearValidation();
						paymentMethods.SetPaymentMethod(el);
					};
					var useCCBtns = [].slice.call(document.querySelectorAll(".btnUsePaymentMethod"));
					useCCBtns.forEach(function (el, index, array) {
						el.removeEventListener("click", usePayment);
						el.addEventListener("click", usePayment);
					});

					const deleteBtns = [].slice.call(document.querySelectorAll(".btnDeleteShipAddress, .btnDeleteCC"));
					deleteModal.BindTriggerElements(deleteBtns);

					var editCC = function (e) {
						e.preventDefault();
						var el = e.currentTarget;
						forms.ClearValidation();
						formEvents.EditCreditCard(el);
					};
					var editCCBtns = [].slice.call(document.querySelectorAll(".btnEditCC"));
					editCCBtns.forEach(function (el, index, array) {
						el.removeEventListener("click", editCC);
						el.addEventListener("click", editCC);
					});
				},

				bindShipAddressEvents = function () {
					if (document.getElementById("btnAddShippingAddress")) {
						document.getElementById("btnAddShippingAddress").removeEventListener("click", formEvents.AddShippingAddress);
						document.getElementById("btnAddShippingAddress").addEventListener("click", formEvents.AddShippingAddress);
					}
					formEvents.NewShippingAddress();

					var useAddy = function (e) {
						e.preventDefault();
						var el = e.currentTarget;
						forms.ClearValidation();
						document.getElementById("divSelectShipAddress").classList.remove("hide");
						document.getElementById("divListShipAddress").classList.add("hide");
						document.getElementById("divNewShippingAddress").classList.add("hide");
						ajaxActions.UpdateShippingAddress(el);
					};
					var useAddyBtns = [].slice.call(document.querySelectorAll(".btnUseShipAddress"));
					useAddyBtns.forEach(function (el, index, array) {
						el.removeEventListener("click", useAddy);
						el.addEventListener("click", useAddy);
					});

					const deleteBtns = [].slice.call(document.querySelectorAll(".btnDeleteShipAddress, .btnDeleteCC"));
					deleteModal.BindTriggerElements(deleteBtns);

					var editAddy = function (e) {
						e.preventDefault();
						var el = e.currentTarget;
						triggerEl = el;
						formEvents.CloseOpenEdits();
						formEvents.EditShippingAddress(el);
					};
					var editAddyBtns = [].slice.call(document.querySelectorAll(".btnEditShipAddress"));
					editAddyBtns.forEach(function (el, index, array) {
						el.removeEventListener("click", editAddy);
						el.addEventListener("click", editAddy);
					});
				},

				bindShipMethodEvents = function () {
					var shipMethodRadios = [].slice.call(document.getElementById("divShippingMethod").querySelectorAll("input[type='radio']"));
					shipMethodRadios.forEach(function (el, index, array) {
						el.addEventListener("click", function () {
							ajaxActions.UpdateItemFreight(el.id);
						});
					});
				},

				removeShippingAddress = function (id) {
					clearShippingAddressError();
					document.getElementById("divShipAddress_" + id).parentNode.parentNode.parentNode.removeChild(document.getElementById("divShipAddress_" + id).parentNode.parentNode);
					shipAddressHeight = 0;
					document.getElementById("btnAddShippingAddress").focus();
					window.scrollTo({ top: 0, behavior: "smooth" });
				},

				removeCreditCard = function (id) {
					clearPaymentMethodError();
					document.getElementById("divPaymentMethod_" + id).parentNode.parentNode.removeChild(document.getElementById("divPaymentMethod_" + id).parentNode);
					document.getElementById("btnAddCC").focus();
					document.getElementById("btnAddCC").scrollIntoView({ top: 0, behavior: "smooth" });
				},

				editShippingAddress = function (element) {
					loadAddress();
					clearShippingAddressError();
					closeOpenEdits();
					var addressId = element.getAttribute("data-ship-address-id");

					//insert the CSS triangle
					document.getElementById("divShipAddress_" + addressId).parentNode.parentNode.classList.add("editJS");

					var setUpAddyForm = function () {
						var hideShip = [].slice.call(document.getElementById("divShipAddress_" + addressId).parentNode.parentNode.querySelectorAll(".hideItem"));
						hideShip.forEach(function (el, index, array) {
							el.classList.add("invisible");
						});
						document.getElementById("divEditShipAddress_" + addressId).scrollIntoView({ top: 0, behavior: "smooth" });
						if (document.getElementById("divEditShipAddress_" + addressId).querySelectorAll("input")[0]) {
							document.getElementById("divEditShipAddress_" + addressId).querySelectorAll("input")[0].focus();
						}
						calculateDivShippingAddressHeight("#divEditShipAddress_" + addressId);

						document.getElementById("divEditShipAddress_" + addressId).getElementsByClassName("formHeading")[0].textContent = document.getElementById("LabelEditAddress").value;
						document.getElementById("divSaveAddressBtn").classList.add("inlineMiddle");
						document.getElementById("divSaveAddressBtn").classList.remove("hide");
						document.getElementById("btnSaveAddress").value = document.getElementById("LabelEditAddressSave").value;
						addressMethods.FillEditAddressForm(addressId);
						triggerEl.setAttribute("aria-expanded", "true");

						document.getElementById("btnSaveAddress").addEventListener("click", function (e) {
							e.preventDefault();
							forms.formValidation(document.getElementById("addressForm"), function () { saveShippingAddress(addressId); }, e);
							calculateDivShippingAddressHeight("#divEditShipAddress_" + addressId);
							triggerEl.setAttribute("aria-expanded", "false");
						});

						document.getElementById("btnCancelSaveAddress").addEventListener("click", function (e) {
							e.preventDefault();
							cancelEditShippingAddress(this);
							triggerEl.setAttribute("aria-expanded", "false");
						});

					};
					// get the form, put it in this container, then do this function
					ajaxActions.GetAddressForm(document.getElementById("divEditShipAddress_" + addressId), setUpAddyForm);
				},

				addShippingAddress = function (e) {
					var element = e.currentTarget;
					loadAddress();
					clearShippingAddressError();
					closeOpenEdits();
					element.classList.add("invisible");

					var setUpAddyForm = function () {
						document.getElementById("FirstName").focus();
						calculateDivShippingAddressHeight("#divAddShipAddress");
						document.getElementById("divAddShipAddress").getElementsByClassName("formHeading")[0].textContent = document.getElementById("LabelAddAddress").value;
						document.getElementById("divSaveAddressBtn").classList.add("inlineMiddle");
						document.getElementById("divSaveAddressBtn").classList.remove("hide");
						document.getElementById("btnSaveAddress").value = document.getElementById("LabelAddAddressSave").value;
						document.getElementById("divListShipAddress").classList.remove("hide");
						addressMethods.FillAddAddressForm();
						element.setAttribute("aria-expanded", "true");

						document.getElementById("btnSaveAddress").addEventListener("click", function (e) {
							e.preventDefault();
							forms.formValidation(document.getElementById("divAddShipAddress"), function () { saveShippingAddress(""); }, e);
							calculateDivShippingAddressHeight("#divAddShipAddress");
							element.setAttribute("aria-expanded", "false");
						});

						document.getElementById("btnCancelSaveAddress").addEventListener("click", function (e) {
							e.preventDefault();
							cancelEditShippingAddress(this);
							element.setAttribute("aria-expanded", "false");
						});
					};
					// get the form, put it in this container, then do this function
					ajaxActions.GetAddressForm(document.getElementById("divAddShipAddress"), setUpAddyForm);
				},

				newShippingAddress = function () {
					if (!document.getElementById("divNewShippingAddress").classList.contains("hide") || document.getElementById('CartModel_IsRegistered').value === 'False') {
						var setUpAddyForm = function () {
							document.getElementById("divNewShippingAddress").querySelector("input").focus();
							document.getElementById("divNewShippingAddress").querySelector(".formHeading").textContent = document.getElementById("LabelNewAddress").value;
							document.getElementById("btnSaveAddress").value = document.getElementById("LabelNewAddressSave").value;
							addressMethods.FillNewAddressForm();

							document.getElementById("btnSaveAddress").classList.add("button-lg");
							document.getElementById("btnSaveAddress").parentNode.classList.add("clear");
							document.getElementById("btnSaveAddress").parentNode.classList.add("smallSpace");
							document.getElementById("btnCancelSaveAddress").parentNode.classList.add("hide");
							document.getElementById("btnCancelSaveAddress").parentNode.classList.remove("inlineMiddle");
							document.getElementById("btnCancelSaveAddress").classList.remove("button-md");
							document.getElementById("divSaveAddressBtn").classList.remove("hide");
							document.getElementById("btnSaveAddress").addEventListener("click", function (e) {
								e.preventDefault();
								forms.formValidation(document.getElementById("divNewShippingAddress"), function () { saveShippingAddress("", true); }, e);
							});
						};
						// get the form, put it in this container, then do this function
						ajaxActions.GetAddressForm(document.getElementById("divNewShippingAddress"), setUpAddyForm);
					}
				},

				calculateDivShippingAddressHeight = function (element) {
					var editDiv = document.querySelector(element);
					// ignore on mobile device
					if (windowWidth > 600) {
						var editHeight = editDiv.offsetHeight;
						// save off original height to recalculate from
						// 100 is offset for top header
						if (!shipAddressHeight) {
							shipAddressHeight = document.getElementById("divListShipAddress").offsetHeight - 100;
						}
						// if edit address height is taller than saved addresses, use that plus top header height
						if (shipAddressHeight < editHeight) {
							var newHeight = editHeight + 100;
							document.getElementById("divListShipAddress").style.height = newHeight + "px";
						}
					}
				},

				closeOpenEdits = function () {
					var divs = document.querySelectorAll("[id^='divEditShipAddress_']");
					for (var i = 0; i < divs.length; i++) {
						var el = divs[i];
						if (el.innerHTML.length > 0) {
							el.innerHTML = "";
							var id = el.id.split("_");
							if (id.length === 2) {
								resetDivShippingAddress(id[1]);
							}
						}
					}
					resetAddShippingAddress();
				},

				cancelEditShippingAddress = function (element) {
					var addressId = document.getElementById("AddressId").value;
					if (addressId.trim().length !== 0) {
						resetDivShippingAddress(addressId);
						document.getElementById("divEditShipAddress_" + addressId).innerHTML = "";
					} else {
						resetAddShippingAddress();
					}
					clearShippingAddressError();
				},

				saveShippingAddress = function (addressId, newCustomer) {
					var shipAddress = addressMethods.GetEditShippingAddress(addressId, newCustomer);
					if (checkShipingAddressLinkToBillingAddress(shipAddress)) {
						confirmModal.Open();
					} else {
						if (login.GetLoginStatus === loginStatuses.AccountSetup) {
							ajaxActions.RegisterAccount(shipAddress);
						} else {
							ajaxActions.SaveShippingAddress(shipAddress);
						}
					}
				},

				checkShipingAddressLinkToBillingAddress = function (address) {
					if (address.AddressId.trim().length === 0) {
						return false;
					}
					var oldAddress = addressMethods.GetExistingAddress("#divShipAddress_" + address.AddressId, addressMethods.ShippingAddressTypeId, true);
					// check if old address is linked and if so was there any changes made
					if (!oldAddress.LinkedAddress) {
						return false;
					}
					if (address.FirstName !== oldAddress.FirstName || address.LastName !== oldAddress.LastName || address.CompanyName !== oldAddress.CompanyName || address.Address1 !== oldAddress.Address1 || address.Address2 !== oldAddress.Address2 || address.City !== oldAddress.City || address.State !== oldAddress.State || address.ZipCode !== oldAddress.ZipCode || address.Phone !== oldAddress.Phone) {
						return true;
					}
					return false;
				},

				resetAddShippingAddress = function () {
					var div = document.getElementById("divAddShipAddress");
					if (div.innerHTML.length > 0) {
						div.innerHTML = "";
						document.getElementById("btnAddShippingAddress").classList.remove("invisible");
						document.getElementById("btnAddShippingAddress").focus();
						document.getElementById("btnAddShippingAddress").scrollIntoView({ top: 0, behavior: "smooth" });
						resetShipAddressHeight();
					}
					document.getElementById("divNewShippingAddress").innerHTML = "";
				},

				resetDivShippingAddress = function (addressId) {
					//remove the CSS triangle
					document.querySelector(".editJS").classList.remove("editJS");
					var hideShip = [].slice.call(document.getElementById("divShipAddress_" + addressId).parentNode.parentNode.querySelectorAll(".hideItem"));
					hideShip.forEach(function (el, index, array) {
						el.classList.remove("invisible");
					});
					document.getElementById("divShipAddress_" + addressId).parentNode.parentNode.querySelector(".btnEditShipAddress").focus();
					document.getElementById("divShipAddress_" + addressId).scrollIntoView({ top: 0, behavior: "smooth" });
					resetShipAddressHeight();
				},

				resetShipAddressHeight = function () {
					document.getElementById("divListShipAddress").removeAttribute("style");
					shipAddressHeight = 0;
				},

				checkIfSmallScreen = function () {
					if (windowWidth < 800) {
						accordions.open(document.getElementById("orderSummaryBody"));
						if (document.getElementById("notesBody")) { // is this on the page any longer?
							accordions.open(document.getElementById("notesBody"));
						}
					}
				},

				editCreditCard = function (element) {
					loadPayment();
					clearPaymentMethodError();
					closeOpenEditsCC();

					var cardId = element.getAttribute("data-card-id");
					//insert the CSS triangle
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.add("editCreditJS");

					var setUpCCForm = function () {
						hidePaymentLoad();
						var hideItems = [].slice.call(document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelectorAll(".hideCCItem"));
						hideItems.forEach(function (el, index, array) {
							el.classList.add("invisible");
						});
						tooltips.init();
						document.getElementById("divEditCC_" + cardId).querySelector("input").focus();
						document.getElementById("divEditCC_" + cardId).scrollIntoView({ top: 0, behavior: "smooth" });
						document.getElementById("divEditCC_" + cardId).querySelector(".formHeading").textContent = document.getElementById("LabelEditCC").value;
						document.getElementById("divEditCC_" + cardId).querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelChangeBillingAddress").value;
						document.getElementById("btnSaveCreditCard").value = document.getElementById("LabelEditCCSave").value;

						// need to update billing 
						if (updatedBillingAddresses) { formEvents.UpdateBillingAddressList(updatedBillingAddresses); }
						bindBillingAddressEvents();

						paymentMethods.FillEditCCForm(cardId);
						formEvents.RemoveCardNumberSpaces(document.getElementById("divEditCC_" + cardId));
						document.getElementById("btnCancelSaveAddress").setAttribute("aria-label", document.getElementById("LabelCancelAddBillingAddress").value);
						document.getElementById("btnCancelSaveAddress").setAttribute("title", document.getElementById("LabelCancelAddBillingAddress").value);
						document.getElementById("divAddressFormBlock").querySelector(".formHeading").textContent = document.getElementById("LabelNewBillAddress").value;
						document.getElementById("btnAddCC").parentNode.classList.add('hide');
						element.setAttribute("aria-expanded", "true");

						document.getElementById("btnSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							element.setAttribute("aria-expanded", "false");
							forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () { saveCC(cardId); }, e);
						});

						document.getElementById("btnCancelSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							element.setAttribute("aria-expanded", "false");
							cancelEditCC();
						});

						document.getElementById("SavedName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
						document.getElementById("CardName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });

						document.getElementById("IsSaved").addEventListener("change", function (e) {
							forms.ShowSaveCardName(document.getElementById("IsSaved"), document.getElementById("SavedName"), document.getElementById("IsDefault"));
						});
						if (errMode) {
							formEvents.HideLoadPage();
							document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = errResponse.Message;
							forms.serverValidation(document.getElementById("divCreditCardFormBlock").querySelector(".infoText"));
							if (document.getElementById("divCreditCardFormBlock").querySelector(".infoText").querySelector("a")) {
								document.getElementById("divCreditCardFormBlock").querySelector(".infoText").querySelector("a").focus();
							}
							document.getElementById("divCreditCardFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
							if (errResponse.PartialView1 === "x") {
								formEvents.DisplayEditBillAddressForm();
								if (document.getElementById("divAddBillAddress").getElementsByClassName("divCancelSaveAddress")[0]) {
									document.getElementById("divAddBillAddress").getElementsByClassName("divCancelSaveAddress")[0].classList.add("hide");
									document.getElementById("divAddBillAddress").getElementsByClassName("divCancelSaveAddress")[0].classList.remove("inlineMiddle");
								}
								if (document.getElementById("btnCancelSaveAddress")) {
									document.getElementById("btnCancelSaveAddress").classList.remove("hide");
								}
							}
						}
					};
					// get the form, put it in this container, execute this function
					ajaxActions.GetCCForm(document.getElementById("divEditCC_" + cardId), setUpCCForm);
				},

				addCreditCard = function (e) {
					//need something for credit card open edits
					e.preventDefault();
					var element = e.currentTarget;
					forms.ClearValidation();
					closeOpenEditsCC();
					formEvents.LoadPayment();
					element.parentNode.classList.add("hide");

					var setUpCCForm = function () {
						formEvents.HidePaymentLoad();
						document.getElementById("divAddCCForm").querySelector("input").focus();
						document.getElementById("divAddCCForm").scrollIntoView({ top: 0, behavior: "smooth" });
						document.getElementById("divAddCCForm").querySelector(".formHeading").textcontent = document.getElementById("LabelAddCC").value;
						document.getElementById("btnSaveCreditCard").value = document.getElementById("LabelAddCCSave").value;

						paymentMethods.FillAddCCForm();
						tooltips.init();
						if (updatedBillingAddresses) { formEvents.UpdateBillingAddressList(updatedBillingAddresses); }
						bindBillingAddressEvents();
						document.getElementById("btnCancelSaveAddress").setAttribute("aria-label", document.getElementById("LabelCancelAddBillingAddress").value);
						document.getElementById("btnCancelSaveAddress").setAttribute("title", document.getElementById("LabelCancelAddBillingAddress").value);
						document.getElementById("divAddressFormBlock").querySelector(".formHeading").textContent = document.getElementById("LabelNewBillAddress").value;
						document.getElementById("btnCancelSaveCreditCard").setAttribute("title", document.getElementById("LabelCancelAddCC").value);
						document.getElementById("btnCancelSaveCreditCard").setAttribute("aria-label", document.getElementById("LabelCancelAddCC").value);
						document.getElementById("IsDefault").checked = false;
						element.setAttribute("aria-expanded", "true");

						document.getElementById("btnSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							forms.UnmaskCCNumber(document.getElementById("CardNumber"));
							forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () { saveCC(""); }, e);
							forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
						});

						document.getElementById("btnCancelSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							element.setAttribute("aria-expanded", "false");
							resetAddCC();
						});

						document.getElementById("SavedName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
						document.getElementById("CardName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });

						document.getElementById("IsSaved").addEventListener("change", function (e) {
							forms.ShowSaveCardName(document.getElementById("IsSaved"), document.getElementById("SavedName"), document.getElementById("IsDefault"));
						});

						var useBillAddyBtns = [].slice.call(document.getElementById("divAddCCForm").querySelectorAll("btnUseBillAddress"));
						useBillAddyBtns.forEach(function (el, index, array) {
							el.addEventListener("click", function (e) {
								e.preventDefault();
								addressMethods.SelectBillingAddress(document.getElementById(el.getAttribute("aria-describedby")));
								showSelectedBilling();
							});
						});

						//this does not fade imgs, but it does do the client side validation for using the accepted credit cards
						document.getElementById('CardNumber').addEventListener('keyup', function () {
							forms.FadeCCImgs(document.getElementById('CardNumber'), document.getElementById('btnSaveCreditCard'), document.getElementById('SavedName'));
							document.getElementById("btnSaveCreditCard").disabled = false;
						});
					};
					// get the form, put it in this container, execute this function
					ajaxActions.GetCCForm(document.getElementById("divAddCCForm"), setUpCCForm);
				},

				closeOpenEditsCC = function () {
					var divs = document.querySelectorAll("[id^='divEditCC_']");
					for (var i = 0; i < divs.length; i++) {
						var el = divs[i];
						if (el.innerHTML.length > 0) {
							el.innerHTML = "";
							var id = el.id.split("_");
							if (id.length === 2) {
								resetDivPaymentMethod(id[1]);
							}
						}
					}
					resetAddCC();
				},

				resetAddCC = function () {
					var div = document.getElementById("divAddCCForm");
					if (div.innerHTML.length > 0) {
						div.innerHTML = "";
						document.getElementById("btnAddCC").parentNode.classList.remove("hide");
						document.getElementById("btnAddCC").focus();
					}
					document.getElementById("divNewCCholder").innerHTML = "";
				},

				cancelEditCC = function (element) {
					var cardID = document.getElementById("CardID").value;
					if (cardID.trim().length !== 0) {
						resetDivPaymentMethod(cardID);
						document.getElementById("divEditCC_" + cardID).innerHTML = "";
					} else {
						resetAddCC();
					}
					document.getElementById("btnAddCC").parentNode.classList.remove('hide');
				},

				saveCC = function (cardId, newCustomer) {
					formEvents.LoadPayment();
					forms.ClearValidation();
					var cCard = paymentMethods.GetEditCC(cardId, newCustomer);

					ajaxActions.GetCreditCardIds(function (updatedCreditCardIds) {
                    cCard.PaymentTypeID = forms.GetPaymentTypeID(updatedCreditCardIds, cCard.CardNumber, cCard.PaymentTypeID);

                    if (cCard.PaymentTypeID < 0) {
                        cCard.PaymentTypeID = getPaymentTypeId(cCard.CardNumber); // forms doesn't always update
                    }

                    cCard.PaymentID = document.getElementById("Cart_UserCart_PymtMethod_PaymentID") ? document.getElementById("Cart_UserCart_PymtMethod_PaymentID").value : "";
                    ajaxActions.SaveCreditCard(cCard);
                });
				},

				getPaymentTypeId = function (cardNumber) {
					var firstDigit = cardNumber.substring(0, 1);
					switch (firstDigit) {
						case "3": // American Express
							return 5;
						case "4": // Visa
							return 3;
						case "2":
						case "5": // MasterCard
							return 4;
						case "6": // Discover
							return 10;
						default: // unknown / error
							return -1;
					}
				},

				newCreditCard = function () {
					if (!document.getElementById("divNewPaymentMethod").classList.contains("hide") && document.getElementById("divNewShippingAddress").classList.contains("hide") && document.getElementById('CartModel_IsRegistered').value !== 'False') {
						document.getElementById('divCCPayOptions').classList.add('hide');
						loadPayment();
						var setUpNewCCForm = function () {
							hidePaymentLoad();
							document.getElementById("divNewCCholder").querySelector(".formHeading").textContent = document.getElementById("LabelEnterCC").value;
							document.getElementById("divNewCCholder").querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelEnterBillingAddress").value;
							document.getElementById("btnCancelSaveCreditCard").classList.add('hide');

							paymentMethods.FillNewCCForm();
							forms.ShowSaveCardName(document.getElementById("IsSaved"), document.getElementById("SavedName"), document.getElementById("IsDefault"));

							if (updatedBillingAddresses) { formEvents.UpdateBillingAddressList(updatedBillingAddresses); }
							document.getElementById("btnCancelSaveAddress").setAttribute("aria-label", document.getElementById("LabelCancelAddBillingAddress").value);
							document.getElementById("btnCancelSaveAddress").setAttribute("title", document.getElementById("LabelCancelAddBillingAddress").value);
							document.getElementById("divAddressFormBlock").querySelector(".formHeading").textContent = document.getElementById("LabelNewBillAddress").value;

							if (document.getElementById("btnSaveCC")) {
								document.getElementById("btnSaveCC").classList.add("button-lg");
								document.getElementById("btnSaveCC").parentNode.classList.add("clear");
								document.getElementById("btnSaveCC").parentNode.classList.add("smallSpace");

								document.getElementById("btnSaveCC").addEventListener("click", function (e) {
									e.preventDefault();
									forms.UnmaskCCNumber(document.getElementById("CardNumber"));
									forms.formValidation(document.getElementById("divNewPaymentMethod"), function () { saveCC("", true); }, e);
									forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
								});
							}
							document.getElementById("btnSaveCreditCard").addEventListener("click", function (e) {
								e.preventDefault();
								forms.UnmaskCCNumber(document.getElementById("CardNumber"));
								forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () { saveCC("", true); }, e);
								forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
							});

							document.getElementById("SavedName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
							document.getElementById("CardName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });

							document.getElementById("btnCancelSaveCreditCard").addEventListener("click", function (e) {
								e.preventDefault();
								cancelEditCC(this);
							});
							document.getElementById("IsSaved").addEventListener("change", function (e) {
								forms.ShowSaveCardName(document.getElementById("IsSaved"), document.getElementById("SavedName"), document.getElementById("IsDefault"));
							});

							document.getElementById('CardNumber').addEventListener('keyup', function () {
								forms.FadeCCImgs(document.getElementById('CardNumber'), document.getElementById('btnSaveCreditCard'), document.getElementById('SavedName'));
								document.getElementById("btnSaveCreditCard").disabled = false;
							});

							bindBillingAddressEvents();
							tooltips.init();
							// prevent focus shift if this is the first time they are loading the page
							if (document.getElementById("editShippingAddress") !== document.activeElement) {
								document.getElementById("CardName").focus();
							}
						};
						// get the form, put it in this container, execute this function
						ajaxActions.GetCCForm(document.getElementById("divNewCCholder"), setUpNewCCForm);
					}
				},

				resetDivPaymentMethod = function (cardId) {
					//remove the CSS triangle
					document.querySelector(".editCreditJS").classList.remove("editCreditJS");
					document.getElementById("divPaymentMethod_" + cardId).scrollIntoView({ top: 0, behavior: "smooth" });
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.remove("bkgdLtGray");
					var hideItems = [].slice.call(document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelectorAll(".hideCCItem"));
					hideItems.forEach(function (el, index, array) {
						el.classList.remove("invisible");
					});
					document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").focus();
				},

				bindBillingAddressListEvents = function () {
					if (document.getElementById("btnCancelSelectBillingAddress")) {
						document.getElementById("btnCancelSelectBillingAddress").addEventListener("click", function (e) {
							document.getElementById("btnSelectBillAddress").setAttribute("aria-expanded", "false");
							document.getElementById("divSelectBillAddress").classList.add("hide");
							document.getElementById("btnSelectBillAddress").focus();
						});
					}

					var useAddyBtns = [].slice.call(document.querySelectorAll(".btnUseBillAddress"));
					useAddyBtns.forEach(function (el, index, array) {
						el.addEventListener("click", function (e) {
							addressMethods.SelectBillingAddress(document.getElementById(el.getAttribute("aria-describedby")));
							showSelectedBilling();
							document.getElementById("btnSelectBillAddress").setAttribute("aria-expanded", "false");
						});
					});
				},

				bindBillingAddressEvents = function () {
					document.getElementById("btnSelectBillAddress").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById("UseShippingAddress").checked = false;
						document.getElementById("divBillAddress").classList.add("hide");
						document.getElementById("btnNewBillAddress").setAttribute("aria-expanded", "false");
						if (document.getElementById("divSelectBillAddress").classList.contains("hide")) {
							document.getElementById("btnSelectBillAddress").setAttribute("aria-expanded", "true");
							document.getElementById("divAddBillAddress").classList.add("hide");
							document.getElementById("divSelectBillAddress").classList.remove("hide");
							document.getElementById("divSelectBillAddress").querySelector(".btnUseBillAddress").focus();
						} else {
							document.getElementById("btnSelectBillAddress").setAttribute("aria-expanded", "false");
							document.getElementById("divSelectBillAddress").classList.add("hide");
						}
					});

					document.getElementById("btnNewBillAddress").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById("UseShippingAddress").checked = false;
						document.getElementById("btnSelectBillAddress").setAttribute("aria-expanded", "false");
						document.getElementById("btnNewBillAddress").setAttribute("aria-expanded", "true");
						forms.ClearValidation();
						document.getElementById("divBillAddress").classList.add("hide");
						if (displayBillAddressForm()) {
							document.getElementById("AddressId").value = "";
							document.getElementById("FirstName").focus();
						}
					});

					document.getElementById("btnCancelSaveAddress").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById("divAddBillAddress").classList.add("hide");
						document.getElementById("btnNewBillAddress").focus();
					});

					document.getElementById("btnCancelSaveAddress").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById("divAddBillAddress").classList.add("hide");
						document.getElementById("btnNewBillAddress").setAttribute("aria-expanded", "false");
						document.getElementById("btnNewBillAddress").focus();
					});

					document.getElementById("UseShippingAddress").addEventListener("change", function (e) {
						formEvents.UseShippingAddressForBilling();
					});

					document.getElementById("btnSaveAddress").addEventListener("click", function (e) {
						e.preventDefault();
						forms.formValidation(document.getElementById("divAddressFormBlock"), saveBillingAddress, e);
					});

					bindBillingAddressListEvents();
				},

				displayBillAddressForm = function () {
					if (document.getElementById("divAddBillAddress").classList.contains("hide")) {
						document.getElementById("divAddBillAddress").classList.remove("hide");
						document.getElementById("divAddBillAddress").getElementsByClassName("formHeading")[0].textContent = document.getElementById("LabelAddAddress").value;
						document.getElementById("divAddBillAddress").classList.remove("hide");
						document.getElementById("divSelectBillAddress").classList.add("hide");
						document.getElementById("divAddressDefault").classList.add("hide");
						document.getElementById("divSaveAddressBtn").classList.remove("hide");
						document.getElementsByClassName("divCancelSaveAddress")[0].classList.add("hide");
						document.getElementsByClassName("divCancelSaveAddress")[0].classList.remove("inlineMiddle");
						document.getElementById("btnCancelSaveAddress").classList.remove("hide");
						document.getElementById("btnSaveAddress").value = document.getElementById("LabelAddAddressSave").value;

						if (document.getElementById("Phone")) {
							document.getElementById("Phone").addEventListener("paste", function (e) {
								forms.FixPastedPhoneNumber(e, document.getElementsByClassName("PhoneMask")[0]);
							});
						}
						return true;
					} else {
						document.getElementById("divAddBillAddress").classList.add("hide");
						return false;
					}
				},

				displayEditBillAddressForm = function () {
					// billing address form should be hidden
					if (!displayBillAddressForm()) {
						displayBillAddressForm();
					}
					document.getElementById("divAddBillAddress").getElementsByClassName("formHeading")[0].textContent = document.getElementById("LabelEditAddress").value;
					document.getElementById("btnSaveAddress").value = document.getElementById("LabelEditAddressSave").value;
					addressMethods.FillEditBillingAddress();
				},

				saveBillingAddress = function () {
					var address = addressMethods.GetNewBillingAddress();
					ajaxActions.SaveBillingAddress(address);
				},

				showSelectedBilling = function () {
					document.getElementById("divBillAddress").classList.remove("hide");
					document.getElementById("divSelectBillAddress").classList.add("hide");
					document.getElementById("divAddBillAddress").classList.add("hide");
					if (addressMethods.CheckSetBillingAndShippingAreSameID()) {
						document.getElementById('UseShippingAddress').checked = true;
					}
				},

				hideSelectedBilling = function () {
					document.getElementById("divBillAddress").classList.add("hide");
				},

				useShippingAddressForBilling = function () {
					if (document.getElementById("UseShippingAddress").checked === true) {
						addressMethods.CopySelectedShippingAddress();
						showSelectedBilling();
					} else {
						addressMethods.ClearSelectedBillingAddress();
						hideSelectedBilling();
					}
				},

				removeCardNumberSpaces = function (element) {
					var cardNumber = element.querySelector("#CardNumber");
					cardNumber.value = cardNumber.value.replace(/\s+/g, '');
				},

				removePaymentMethodError = function () {
					if (document.querySelector(".infoTextCC")) {
						document.querySelector(".infoTextCC").innerHTML = "";
					}
				},

				showPaymentMethodPanel = function () {
					var numberOfCCs = document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : "";
					if (parseInt(numberOfCCs) === 0) {
						document.getElementById('divCCPayOptions').classList.add('hide');
						document.getElementById("divNewPaymentMethod").classList.remove("hide");
						formEvents.NewCreditCard();
					}
					else {
						document.getElementById("divNewPaymentMethod").classList.add("hide");
						document.getElementById('divCCPayOptions').classList.remove('hide');
						hidePaymentLoad();
					}
				},

				updateShippingAddressList = function (addressList) {
					document.getElementById("divListShipAddress").innerHTML = addressList;
					bindShipAddressEvents();
				},

				updateBillingAddressList = function (addressList) {
					if (document.getElementById("divSelectBillAddress")) {
						document.getElementById("divSelectBillAddress").innerHTML = addressList;
					}
				},

				verifyCreditCardAuthorized = function (creditCard) {
					return creditCard.IsAuthorized || !!creditCard.CardCCV;
				},

				putCreditCardInEditMode = function (cardId, editPaymentMethod) {
					var putInEdit = function () {
						if (editPaymentMethod) {
							paymentMethodEditMode = true;
							updateView();
							document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").click();
						} else {
							document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").click();
							document.getElementById("btnSaveCreditCard").click();
						}
					};
					// get the form, put it in this container, execute this function
					ajaxActions.GetCCForm("", putInEdit);
				},
				putCreditCardInEditModeWithErrors = function (cardId, editPaymentMethod, response) {
					var putInEdit = function () {
						errMode = true;
						errResponse = response;
						if (editPaymentMethod) {
							paymentMethodEditMode = true;
							updateView();
							document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").click();
						} else {
							document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").click();
							document.getElementById("btnSaveCreditCard").click();
						}
					};
					ajaxActions.GetCCForm("", putInEdit);
				},

				putShippingAddressInEditMode = function (cartId) {
					formEvents.HideLoadPage();
					document.getElementById("editShippingAddress").click();
					formEvents.ShowAjaxMessage(jsMessages.missingShipAddress);
					window.appInsights && appInsights.trackTrace({ message: "Shipping address is missing during submit cart id " + cartId }, { gurid: document.getElementById("UserCart_GURID").value });
				};

			return {
				ShowEnterCouponCode: showEnterCouponCode,
				HideEnterCouponCode: hideEnterCouponCode,
				SubmitCouponCode: submitCouponCode,
				CouponCodeError: couponCodeError,
				AddCouponCode: addCouponCode,
				DeleteCouponCode: deleteCouponCode,
				ShowAjaxMessage: showAjaxMessage,
				HideAjaxMessage: hideAjaxMessage,
				LoadPage: loadPage,
				HideLoadPage: hideLoadPage,
				LoadCoupon: loadCoupon,
				HideLoadCoupon: hideLoadCoupon,
				LoadAddress: loadAddress,
				HideAddressLoad: hideAddressLoad,
				LoadFreight: loadFreight,
				HideFreightLoad: hideFreightLoad,
				LoadPayment: loadPayment,
				HidePaymentLoad: hidePaymentLoad,
				ReloadPage: reloadPage,
				ShowPaymentOptions: showPaymentOptions,
				ShowLineOfCreditInfo: showLineOfCreditInfo,
				UpdateCartTotals: updateCartTotals,
				ShippingAddressEditMode: shippingAddressEditMode,
				ShippingAddressDefaultMode: shippingAddressDefaultMode,
				UpdateShippingAddress: updateShippingAddress,
				UpdateShippingMethods: updateShippingMethods,
				UpdateSelectedShippingAddress: updateSelectedShippingAddress,
				UpdateShippingAddressError: updateShippingAddressError,
				SavingShippingAddressError: savingShippingAddressError,
				ClearShippingAddressError: clearShippingAddressError,
				RemoveShippingAddress: removeShippingAddress,
				EditShippingAddress: editShippingAddress,
				ResetDivShippingAddress: resetDivShippingAddress,
				ResetShipAddressHeight: resetShipAddressHeight,
				AddShippingAddress: addShippingAddress,
				NewShippingAddress: newShippingAddress,
				PaymentMethodDefaultMode: paymentMethodDefaultMode,
				PaymentMethodEditingMode: paymentMethodEditingMode,
				UpdatePaymentMethods: updatePaymentMethods,
				UpdateCvv: updateCvv,
				ClearPaymentMethodError: clearPaymentMethodError,
				SettingPaymentMethodError: settingPaymentMethodError,
				ResetBillMeLater: resetBillMeLater,
				RemoveCreditCard: removeCreditCard,
				UpdatePaymentMethodInvoice: updatePaymentMethodInvoice,
				EditCreditCard: editCreditCard,
				AddCreditCard: addCreditCard,
				NewCreditCard: newCreditCard,
				ResetDivPaymentMethod: resetDivPaymentMethod,
				UseShippingAddressForBilling: useShippingAddressForBilling,
				HideSelectedBilling: hideSelectedBilling,
				ShowSelectedBilling: showSelectedBilling,
				ShowNewAddressForm: showNewAddressForm,
				RemovePaymentMethodError: removePaymentMethodError,
				ShowPaymentMethodPanel: showPaymentMethodPanel,
				UpdateShippingAddressList: updateShippingAddressList,
				UpdateBillingAddressList: updateBillingAddressList,
				BindBillingAddressListEvents: bindBillingAddressListEvents,
				DisplayEditBillAddressForm: displayEditBillAddressForm,
				VerifyCreditCardAuthorized: verifyCreditCardAuthorized,
				PutCreditCardInEditMode: putCreditCardInEditMode,
				set PaymentMethodEditMode(mode) { paymentMethodEditMode = mode; },
				CheckIfSmallScreen: checkIfSmallScreen,
				CheckCartHasCoupon: checkCartHasCoupon,
				BindShipAddressEvents: bindShipAddressEvents,
				BindShipMethodEvents: bindShipMethodEvents,
				BindPaymentMethodEvents: bindPaymentMethodEvents,
				HideBusy: hideBusy,
				RemoveCardNumberSpaces: removeCardNumberSpaces,
				CalculateDivShippingAddressHeight: calculateDivShippingAddressHeight,
				CloseOpenEdits: closeOpenEdits,
				PutCreditCardInEditModeWithErrors: putCreditCardInEditModeWithErrors,
				PutShippingAddressInEditMode: putShippingAddressInEditMode,
				UpdateView: updateView,
				BindAddressAutoComplete: bindAddressAutoComplete,
				DisplayFlag: displayFlag,
                SaveCC : saveCC
			};
		})();

	return {
		Init: init
	};
};

(function () {
	var checkoutPage = new checkout4i();
	checkoutPage.Init();
})();